import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, PopoverController, ModalController, AlertController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import * as moment from 'moment';
import { AmChartsService, AmChart } from "@amcharts/amcharts3-angular";
import { VehicleService } from '../../../vehicles';
import { PopupPage } from '../../popup/popup';
import { AddpoimapPage } from '../../mapview/addpoimap/addpoimap'
import { AddzonePage } from '../../mapview/addzone/addzone';
import { CalcdistancePage } from '../../mapview/calcdistance/calcdistance';

// import * as HighCharts from 'highcharts';

// import { Chart } from 'chart.js';
// import * as Highcharts from 'Highcharts'

declare var google;
declare var ol;
declare var RichMarker;
declare var RichMarkerPosition;
declare var MeasureTool;
declare var playRecIdx;
declare var playRectf;
declare var _timeout;
declare var pb;
// declare var AmCharts;
// @IonicPage({
//   name: 'reconstrunction'
// })

@Component({
  selector: 'page-reconstrunction',
  templateUrl: 'reconstrunction.html',
})
export class ReconstrunctionPage {
  @ViewChild('mapHistory') mapElement: ElementRef;

  tmpInterval: any
  measureTool: any = null;
  playRecIdx = 0
  playRectf: any = false;
  pb: any = -2
  playrecopt = 0;
  _timeout: any;
  _timeout1: any;
  AllPois = []
  AllZones = []
  AllZonesMap = []
  Pois = []
  Areas = []
  googleX: any
  googleY: any

  allStops = []
  allTowUps = []

  newZonePoints = []
  newZoneLayerLine = []
  newZoneLayerPoly = []
  newZoneLayerPoints = []
  tempZones = []
  lastPoiGroup = -1
  Group = []

  lastUMouse: any
  intervalUnderMouse = 0

  MapSelectedButton = ''
  MapSelectedButton1 = ''
  MapSelectedButtontmp = ''
  loadingData: boolean = true
  priv: boolean = false
  startDate: any
  endDate: any
  sdOrg: any
  edOrg: any
  arrDays = []
  selectedDay: any
  vehicles = []
  vehicleDB: any
  reportType: any
  actionPath = [];
  historyMap: any;
  historyMarker: any;
  historyMarkerMultiple = []
  pinMarker: any;

  pinMarkers = [];
  seMarkers = [];

  MapType: any = 'GOOGLE';
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  lineColors = ['#017afd', '#f68c3a', '#54d469', '#ff6666', '#5c93c4', '#5c00e6', '#ff80d5', '#00ccff', '#990000', '#996633']
  lineColors1 = ['#0158B6', '#aa4e08', '#248f36', '#cc0000', '#2f5c83', '#330080', '#b30077', '#007a99', '#4d0000', '#4d3319']
  driverVehicles = []
  hasBuzzOneVeh = false

  vhistory = 0;
  vhis: any;
  path = [];
  pathBuzzer = [];
  _speed = []
  _speed2 = []
  _speed3 = []
  _speedLimit = []
  _dt = []
  _dt2 = []
  _dt3 = []
  _ign = []
  _ign2 = []
  _ign3 = []
  MyChart: any;
  MyChartData = []
  recData = []
  recDataMultiple = []
  ignOffOne = []
  maxSpeedRec = []
  maxSpeedRec2 = []
  maxSpeedRec3 = []
  fuelDown = []
  checkForFuelDown = -1
  checkForFuelDownNow = -1
  checkForFuelDownDt = ''
  Fuel = []
  HaveFuel = false
  Odometer = []
  HaveOdometer = false
  // MyMarker:any
  infowindowHistoryMarkers: any = new google.maps.InfoWindow({});;
  myChart: any
  motorOff = []
  NoData = false
  loadSpinner = false
  chartDataOpened = true

  tmpZoneid: any
  startTime = '';
  endTime = '';
  PageType = ''
  selectedGroupID = 1;
  fuelcapacity = 0;
  currday = 0;
  lastIdxVeh = 0;
  idxVeh = 0;
  isIdleRep: any;
  idleObj = [];
  isIntRep: any;
  isShortRep: any;

  buzzerdt = ''
  buzzerlon = ''
  buzzerlat = ''

  timerSpeed = 300
  timerSpeedVal = 300
  timerSpeedInit = 300
  repfuelDownDt: any

  tochkiPoseta = [];
  _copyCoords = []
  _copyAddress = ''
  ContextMenu: any;
  totaltime2 = ''
  totaldistance2 = '0'
  disablebutton: boolean = false
  linestring = ''
  linestring2 = ''

  popovertemp: any
  typeofroute = 'fastest'


  KmOrMShorterst = 'Km'
  KmOrMFastest = 'Km'

  calcfromleftpanel = false
  PathLines = []
  PathLines2 = []
  _traffic = false;
  trafficLayer;
  shortRoute = true;
  fastRoute = true;

  AutoCompleteShow = false
  AutoCompleteTop = '0px'
  AutoCompleteTitle = ''
  InFocused = false
  AutoCompleteState = 0
  AutoCompleteIndex = 0

  pointCount = 2


  RouteDetails = false
  timeWithOut = ''
  _zadrzuvanje = ''
  _Distance = ''
  _totaltime = 0
  _totaltimeStr = ''
  _Pauses = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
  SelPauses = []
  Pauzi = []
  RouteTitle = ''
  NalogId = -1
  NalogNum = ''
  RouteTotalDistance = 0
  selectedCultureStr = ''
  selectedCultureId = 0
  selectedOperationStr = ''
  selectedOperationId = 0
  selectedMaterialStr = ''
  selectedMaterialId = 0
  selectedMechanStr = ''
  selectedMechanId = 0
  _Culture = []
  _Operation = []
  _Material = []
  _Mechan = []
  DataPredefined = []
  showReportPanel = false
  showNewRoutePanel = false
  showNewPreRoutePanel = false
  showEditRoutePanel = false
  showProgressRoutePanel = false
  showFutureRoutePanel = false
  showPrintPanel = false
  showPrintPanelPatenVehicle = false
  showPrintPanelPatenTruck = false
  showPrintPanelPatenBus = false
  _PrintNalog: any
  showLeftNew = false;
  downloadPre = false;
  loadingDataEdit = false
  //path = ''
  reportData = []
  reportDataPaten = []
  r_routeNumber = ''
  r_routeName = ''

  AutoCompleteShow2 = false
  AutoCompleteState2 = 0
  LoadingDataSearch2 = false
  mapSearcData2 = []
  selectedPoiRep: any = null

  mapSearcData = []
  LoadingDataSearch: boolean = false
  mapSearchFocus: boolean = false
  loadDataCalculate = false;

  selectedVehicleId = ''
  selectedVehicleId2 = -1;

  // selectedDriverIds = []

  selectedTime = new Date().getHours() + 1 + ":00";
  selectedDriver = '--- ' + this.dic.l["ChooseDriverR"] + ' ---';
  selectedCoDrivers = '--- ' + this.dic.l["ChooseCoDriversR"] + ' ---';
  selectedDriverIds = []
  selectedCoDriversIds = []
  selectedBreak = '--- Изберете пауза ---';
  selectedBreakIds = []
  idle: any = '1';
  checkR = 0;
  cntMultiple = 0;
  graphTmp = false
  _ksource = false;

  myMapDiv = null

  // mapSearchText = ''

  // flightPath:any
  Traektorii = []
  _adminbuzzpath = []

  loadDataCounter = 0
  loadDataCounterMax = 0
  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public toastCtrl: ToastController, public AmChart: AmChartsService, public vs: VehicleService, public popoverCtrl: PopoverController, public modalCtrl: ModalController, public alertCtrl: AlertController) {
    this.startDate = navParams.get('sd')
    this.sdOrg = this.startDate
    this.endDate = navParams.get('ed')
    this.edOrg = this.endDate
    this.vehicles = navParams.get('v')
    this.reportType = navParams.get('t')
    this.startTime = navParams.get('st')
    this.endTime = navParams.get('et')
    this.tmpZoneid = navParams.get('zoneid')
    this.PageType = this.navCtrl.getType()
    this.isIdleRep = navParams.get("idlerep")
    this.isIntRep = navParams.get("intrep")
    this.isShortRep = navParams.get("shortrep")

    this.buzzerdt = navParams.get("buzzerdt")
    this.buzzerlon = navParams.get("buzzerlon")
    this.buzzerlat = navParams.get("buzzerlat")

    this.repfuelDownDt = navParams.get("fueldowndt")
    this.graphTmp = false;
    this._ksource = navParams.get('ksource') == undefined ? false : navParams.get('ksource');

    this.InitReconstruction()
    // if (window["PanoramaHistoryMap"]!=null){
    // window["PanoramaHistoryMap"] = null
    // google.maps.event.clearInstanceListeners(window);
    // google.maps.event.clearInstanceListeners(document);
    // if (document.getElementById('mapHistory')!=null){
    //   google.maps.event.clearInstanceListeners(document.getElementById('mapHistory'));
    // }
    // }
    // console.log()
    // console.log(this.startTime, this.endTime)
  }

  ionViewDidLoad() {

  }
  InitReconstruction() {
    // console.log('Vo init Reconstruction')
    var _that = this
    console.log(document.getElementById('mapHistory'))
    if (document.getElementById('mapHistory') == null) {
      setTimeout(function () {
        _that.InitReconstruction()
      }, 100)
      return
    }
    // return
    // google.maps.event.addDomListener(window, 'load', function(){
    //   console.log('google.maps.event.addDomListener')
    // });
    console.log('# BEFORE #')
    // if (!this._ksource) {
    //   return false;
    // }
    // window["PanoramaHistoryMap"] = function(){
    // _that.loadData()
    // }
    console.log('# AFTER #');
    this.tochkiPoseta[0] = { ispoi: 1, id: 's', name: "дестинација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null }
    this.tochkiPoseta[1] = { ispoi: 1, id: 'e', name: "дестинација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null }
    if (this.gn.Vehicles[0] == undefined) {
      this.loadingData = false;
      this.priv = true;
      return false;
    }

    if (this.startDate != null) {

      if (this.tmpInterval == null) {
        setInterval(function () {
          // _that.timerUnderMouse()
          _that.intervalUnderMouse += 1
          if (_that.intervalUnderMouse == 20) {
            _that.intervalUnderMouse = 0
            _that.timerUnderMouse()
          }
        }, 50)
      }


      if (this.vehicles.length == 1) {
        if (this.vehicles[0] + '' == '0') {
          this.vehicles = []
          for (var i = 0; i < this.gn.Vehicles.length; i++) {
            this.vehicles.push(this.gn.Vehicles[i].vehicleid)
          }
        }
      }

      var _diff = (moment(this.endDate)).diff(moment(this.startDate), 'days') + 1;
      if (this.navParams.get('multdays') + '' != 'false' && _diff > 1) {
        var _right = 20;
        for (var i = 0; i < _diff; i++) {
          var tmpDate = moment(this.endDate + ' ' + this.startTime + ':00').subtract(i, 'days');
          var tmpDateYMD = tmpDate.format('YYYY-MM-DD');// HH:mm:ss')
          var tmpDateDay1 = tmpDate.format('DD')
          var tmpDateDay2 = this.dic.l[tmpDate.format('MMMM')]
          this.arrDays.push({ dateYMD: tmpDateYMD, day: tmpDateDay1, month: tmpDateDay2, right: (_right + (55 * i)) + 'px' })
        }
      }

      //moment(this.startDate + ' ' + this.startTime + ':00').format('DD-MM-YYYY HH:mm:ss')
      // setTimeout(function(){
      _that.loadData()
      // }, 500)

    }
  }

  ionViewWillLeave() {
    if (!this._ksource) {
      return false;
    }
    console.log('VO LEAVE')
    if (this.tmpInterval != null) {
      clearInterval(this.tmpInterval)
      this.tmpInterval = null
    }
  }

  drawPolygone() {

    if (this.tmpZoneid != null) {
      var _that = this
      this.gn._Post('/api/gn/getonezone', { zid: this.gn.crypt(this.tmpZoneid) }, function (_data) {
        // console.log(_data[0])
        for (var i = 0; i < _data.length; i++) {
          // console.log()
          var _pois = _data[i].pois.split(",")
          var pp = []
          for (var j = 0; j < _pois.length; j++) {
            var tmp = _pois[j].split(' ')
            pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
          }
          // console.log(_data[i].color, pp, _data[i].name)
          // var idx = _that.drawPoly(_data[i].color, pp, _data[i].name, _id)
          // _that.tempZones[_id + ''] = { data: _data, index: idx }
          // _that.CenterMap2thisPois(pp)
          _that.drawPoly(_data[i].color, pp, _data[i].name)
        }
      })
    }
  }

  drawPoly(_color, _pois, _title) {
    // console.log('drawPoly', _color, _pois, _title)
    var _pp = []
    for (var i = 0; i < _pois.length; i++) {
      _pp.push({ lat: _pois[i].lat, lng: _pois[i].lon })
    }
    var _poly = new google.maps.Polygon({
      paths: _pp,
      strokeColor: _color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: _color,
      fillOpacity: 0.35
    });
    // console.log(this.historyMap)
    _poly.setMap(this.historyMap)
    // this.Areas.push(_poly)
    // _poly.AreaName = _title
    // _poly.AreaId = _zoneid
    // _poly.AreaColor = _color
  }

  prevloadData(_dt) {
    this.resetVariables();
    this.startDate = _dt
    this.endDate = _dt
    var _that = this
    setTimeout(function () {
      _that.loadData();
    }, 100)

  }
  resetVariables() {
    // console.log('vleze vo resetVariables()')
    this.checkR = 0;
    this.cntMultiple = 0;
    this.tmpInterval = undefined
    this.measureTool = null;
    this.lastPoiGroup = -1
    this.AllPois = []
    this.AllZones = []
    this.Pois = []
    this.Areas = []
    this.googleX = undefined
    this.googleY = undefined
    this.lastUMouse = undefined
    //this.intervalUnderMouse = 0

    this.MapSelectedButton1 = ''
    this.MapSelectedButton = ''
    this.loadingData = true
    // this.priv = false
    //this.startDate = undefined
    //this.endDate = undefined
    //this.arrDays = []
    //this.selectedDay = undefined
    //this.vehicles = []
    //this.reportType = undefined
    this.actionPath = [];
    // this.historyMap = undefined
    // this.historyMarker = undefined
    if (this.historyMarker != undefined) {
      this.historyMarker.setMap(null)
      this.historyMarker = undefined
    }
    if (this.historyMarker != null) {
      this.historyMarker.setMap(null)
      this.historyMarker = null
    }
    for (var i = 0; i < this.historyMarkerMultiple.length; i++) {
      if (this.historyMarkerMultiple[i] != null) {
        this.historyMarkerMultiple[i].setMap(null)
        this.historyMarkerMultiple[i] = null
      }
    }
    this.historyMarkerMultiple = []

    for (var i = 0; i < this.Traektorii.length; i++) {
      if (this.Traektorii[i] != null) {
        this.Traektorii[i].setMap(null)
        this.Traektorii[i] = null
      }
    }
    this.Traektorii = []

    for (var i = 0; i < this.pinMarkers.length; i++) {
      if (this.pinMarkers[i] != null) {
        this.pinMarkers[i].setMap(null)
        this.pinMarkers[i] = null
      }
    }
    this.pinMarkers = []

    for (var i = 0; i < this.seMarkers.length; i++) {
      if (this.seMarkers[i] != null) {
        this.seMarkers[i].setMap(null)
        this.seMarkers[i] = null
      }
    }
    this.seMarkers = []

    this.MapType = 'GOOGLE';

    // if (this.flightPath != null) {
    //   this.flightPath.setMap(null)
    //   this.flightPath = null
    // }



    //this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    this.path = [];
    this.pathBuzzer = [];
    this._speed = []
    this._speed2 = []
    this._speed3 = []
    this._speedLimit = []
    this._ign = []
    this._ign2 = []
    this._ign3 = []
    this._dt = []
    this._dt2 = []
    this._dt3 = []
    //this.MyChart = undefined
    if (this.MyChart != undefined && this.MyChart != null) {
      this.MyChart.clear();
      this.MyChart = undefined;
      this.NoData = true
    }
    this.MyChartData = []
    this.recData = []
    this.recDataMultiple = []
    this.maxSpeedRec = []
    this.maxSpeedRec2 = []
    this.maxSpeedRec3 = []
    this.fuelDown = []
    this.checkForFuelDown = -1
    this.checkForFuelDownNow = -1
    this.checkForFuelDownDt = ''
    this.Fuel = []
    this.HaveFuel = false
    this.Odometer = []
    this.HaveOdometer = false
    // MyMarker:any
    this.infowindowHistoryMarkers = new google.maps.InfoWindow({});;
    this.myChart = undefined
    this.motorOff = []
    this.NoData = false
    this.loadSpinner = false
    this.currday = 0
    this.chartDataOpened = true

    //this.tmpZoneid = undefined
    //this.startTime = '';
    //this.endTime = '';
    //this.PageType = ''

    this.tmpInterval = undefined
    this.playRecIdx = 0
    this.playRectf = false;
    this.pb = -2
    this.playrecopt = 0;
    this._timeout = undefined;
    this._timeout1 = undefined;
    this.timerSpeed = 300
    this.timerSpeedVal = 300
    this.timerSpeedInit = 300;
  }

  resetVariables1() {

    this.AllPois = []
    this.AllZones = []
    this.Pois = []
    this.Areas = []
    this.actionPath = [];
    this.path = [];
    this.pathBuzzer = [];
    this.recData = []
    this.recDataMultiple = []
  }


  createMapElement() {
    console.log('Vleze vo CreateElement')
    this.myMapDiv = document.createElement('DIV')
    this.myMapDiv.style.width = '100%'
    this.myMapDiv.style.height = '100%'
    this.myMapDiv.className = "tmpMapGoranDiv"
    console.log('GORAN 1=' + document.getElementById('mapHistory').children.length)
    document.getElementById('mapHistory').appendChild(this.myMapDiv)
    // console.log(this.myMapDiv)

  }
  loadData() {
    var _that = this;
    // console.log(document.getElementById('mapHistory'))
    // if (this.loadingData==true){
    //   setTimeout(function(){
    //     _that.loadData()
    //   }, 500)
    //   return
    // }
    this.graphTmp = false;
    this.driverVehicles = []
    this.selectedDay = this.endDate;
    var logvozila = this.gn.getVehiclesLog(this.vehicles);
    var logperiod = 'Период од: ' + moment(this.startDate + ' ' + this.startTime + ':00').format('DD-MM-YYYY HH:mm:ss') + ' до: ' + moment(this.endDate + ' ' + this.endTime + ':59').format('DD-MM-YYYY HH:mm:ss');
    this.gn.addLog(21, logperiod + ' за возилата: ' + logvozila);

    this.loadingData = true
    this.priv = this.gn.getPriv('reconstruction')
    if (this.priv) {
      this.NoData = false
      this.recData = [];
      this.recDataMultiple = [];
      this.maxSpeedRec = []
      this.maxSpeedRec2 = []
      this.maxSpeedRec3 = []
      this.fuelDown = []
      this.checkForFuelDown = -1
      this.checkForFuelDownNow = -1
      this.checkForFuelDownDt = ''
      this.motorOff = []
      this.Fuel = []
      this.HaveFuel = false
      this.Odometer = []
      this.HaveOdometer = false

      //lupa od izvestaj za somnitelni padovi
      if (this.repfuelDownDt != undefined)
        this.fuelDown.push({ dt: moment(this.repfuelDownDt) })


      var _datV = {
        driverid: this.gn.crypt(this.gn.user.driverid),
        dt: this.gn.crypt(this.endDate),
        vid: this.gn.crypt(this.vehicles)
      }
      this.gn._Post('/api/gn/reports/getDriverVehReconstruction', _datV, function (_dataV) {
        //nema niedno vozilo
        // _that.driverVehicles = []
        // _that._speed = []
        if (_dataV.data.length == 0) {
          _that.NoData = true;
          console.log('###5', _that.NoData)
          let mapOptions1 = {
            mapTypeControl: true,
            mapTypeControlOptions: {
              style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: google.maps.ControlPosition.LEFT_TOP,
              mapTypeIds: [
                google.maps.MapTypeId.ROADMAP,
                google.maps.MapTypeId.HYBRID
              ]
            },
            zoomControl: true,
            scaleControl: true,
            fullscreenControl: false,
            streetViewControl: true,
          }
          if (_that.historyMap == undefined) {
            if (_that.myMapDiv == null) { _that.createMapElement() }
            _that.historyMap = new google.maps.Map(_that.myMapDiv, mapOptions1);
            // window["PanoramaHistoryMap"] = _that.historyMap
          }
          _that.historyMap.setCenter(new google.maps.LatLng(41, 21))
          _that.historyMap.setZoom(5)
          _that.loadSpinner = false
          _that.currday = 0
          _that.drawPolygone()
          google.maps.event.trigger(_that.historyMap, "resize");
          _that.myMapDiv.addEventListener("mousemove", function (e) {
            _that.googleX = e.screenX - 50
            _that.googleY = e.screenY
          });
        }

        if (!_that.isIdleRep && !_that.isIntRep) {
          var bounds = new google.maps.LatLngBounds();
        }
        _that.loadDataCounter = 0
        _that.loadDataCounterMax = _dataV.data.length

        _that.NoData = true
        for (var v = 0; v < _dataV.data.length; v++) {

          if (!_that.isIdleRep && !_that.isIntRep) {

            _that.resetVariables1();
            _that.vehicleDB = _dataV.data[v].vid
            _that.driverVehicles.push({ vid: _dataV.data[v].vid, color: _that.lineColors[v % 10], })

            if (_that.startTime == '/' || _that.startTime == undefined) {
              _that.startTime = '00:00'
            }
            if (_that.startTime.substring(_that.startTime.length - 1, _that.startTime.length) == ":") {
              _that.startTime = _that.startTime.substring(0, _that.startTime.length - 1);
            }
            if (_that.endTime == '/' || _that.endTime == undefined) {
              _that.endTime = '23:59'
            }
            if (_that.endTime.substring(_that.endTime.length - 1, _that.endTime.length) == ":") {
              _that.endTime = _that.endTime.substring(0, _that.endTime.length - 1);
            }

            if (_that.isShortRep) {
              var _dat = {
                last: _that.gn.crypt(_dataV.data.length),
                idx: _that.gn.crypt(v),
                vehiddb: _that.gn.crypt(_that.vehicleDB), //za sofer
                v: _that.gn.crypt(v),
                //sdate: _that.gn.crypt(_that.startDate + ' ' + _that.startTime + ':00'),
                sdate: _that.startDate != _that.endDate ? _that.gn.crypt(_that.startDate + ' ' + _that.startTime + ':00') : _that.gn.crypt(_that.endDate + ' ' + _that.startTime + ':00'),
                edate: _that.gn.crypt(_that.endDate + ' ' + _that.endTime + ':59'),
                vid: _that.gn.crypt(_that.vehicleDB),
                allowus: _that.gn.crypt(_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicleDB)]].allowultrasonic)
              }
            } else {
              var _diffDaysS = moment.duration(moment(_that.endDate).diff(moment(_that.sdOrg))).asDays();
              var _diffDaysE = moment.duration(moment(_that.endDate).diff(moment(_that.edOrg))).asDays();

              var stime = _diffDaysS == 0 ? (_that.startTime + ':00') : '00:00:00'
              var etime = _diffDaysE == 0 ? (_that.endTime + ':59') : '23:59:59'

              var _dat = {
                last: _that.gn.crypt(_dataV.data.length),
                idx: _that.gn.crypt(v),
                vehiddb: _that.gn.crypt(_that.vehicleDB), //za sofer
                v: _that.gn.crypt(v),
                //sdate: _that.gn.crypt(_that.startDate + ' ' + _that.startTime + ':00'),
                sdate: _that.gn.crypt(_that.endDate + ' ' + stime/*_that.startTime + ':00'*/),
                edate: _that.gn.crypt(_that.endDate + ' ' + etime/*_that.endTime + ':59'*/),
                vid: _that.gn.crypt(_that.vehicleDB),
                allowus: _that.gn.crypt(_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicleDB)]].allowultrasonic)
              }
            }
          } else {
            var _dat = {
              last: _that.gn.crypt(_dataV.data.length),
              idx: _that.gn.crypt(v),
              vehiddb: _that.gn.crypt(_that.vehicleDB), //za sofer
              v: _that.gn.crypt(v),
              //sdate: _that.gn.crypt(_that.startDate + ' ' + _that.startTime + ':00'),
              sdate: _that.gn.crypt(_that.endDate + ' ' + _that.startTime),
              edate: _that.gn.crypt(_that.endDate + ' ' + _that.endTime),
              vid: _that.gn.crypt(_that.vehicleDB),
              allowus: _that.gn.crypt(_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicleDB)]].allowultrasonic)
            }
          }


          _that.loadSpinner = true
          _that.gn._Post('/api/gn/reports/reconstructHistory', _dat, function (_data) {

            _that.fuelcapacity = _data.fuelcapacity
            _that.lastIdxVeh = _data.last
            _that.idxVeh = _data.idx
            _that.vhistory = _data.v
            _that.vehicleDB = _data.vehiddb

            _that.currday = _data.currday

            var _data = _data.data

            _that.loadingData = false

            if (_data.length > 1) {
              _that.NoData = false
            } else {
              //_that.NoData = true
            }
            // var arr = _data[0].getreconstruction_viktor.split('#')
            // for (var i = 1; i < arr.length; i++) {
            //   var v = _that.vs.parseData(arr[i])
            //   _that.recData.push(v)
            // }
            _that.recData = []

            _data.forEach(element => {
              console.log(_that.vehicleDB)
              if (_that.gn.checkDtVehAllowShift(element.datetime, parseInt(_that.vehicleDB))) {

                element.dateOrg = moment(element.datetime).toDate()
                _that.recDataMultiple.push(element)
                let latLng = new google.maps.LatLng(parseFloat(element.lat), parseFloat(element.lon));
                bounds.extend(latLng);

                _that.recData.push(element)
              }
            })

            // _that.recData.forEach(element => {
            //   element.dateOrg = moment(element.datetime).toDate()
            //   _that.recDataMultiple.push(element)
            //   let latLng = new google.maps.LatLng(parseFloat(element.lat), parseFloat(element.lon));
            //   bounds.extend(latLng);
            // });


            // console.log('_that.recData.length', _that.recData.length)
            // _that.actionPath = _data;
            if (_that.recData.length == 0) {
              // // let toast = _that.toastCtrl.create({
              // //   message: 'NO RESULTS. Please choose another date',
              // //   duration: 2500,
              // //   position: 'top'
              // // });
              // toast.present();
              let mapOptions1 = {
                mapTypeControl: true,
                mapTypeControlOptions: {
                  style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                  position: google.maps.ControlPosition.LEFT_TOP,
                  mapTypeIds: [
                    google.maps.MapTypeId.ROADMAP,
                    google.maps.MapTypeId.HYBRID
                  ]
                },
                zoomControl: true,
                scaleControl: true,
                fullscreenControl: false,
                streetViewControl: true,
              }
              if (_that.historyMap == undefined) {
                if (_that.myMapDiv == null) { _that.createMapElement() }
                _that.historyMap = new google.maps.Map(_that.myMapDiv, mapOptions1);
                // window["PanoramaHistoryMap"] = _that.historyMap
              }
              _that.historyMap.setCenter(new google.maps.LatLng(41, 21))
              _that.historyMap.setZoom(5)
              _that.loadSpinner = false
              _that.drawPolygone()
              google.maps.event.trigger(_that.historyMap, "resize");
              _that.myMapDiv.addEventListener("mousemove", function (e) {
                _that.googleX = e.screenX - 50
                _that.googleY = e.screenY
              });
              // debugger
              if (_that.gn.user.driverid + '' == '-1' && _that.vehicles.length > 1) {
                _that.checkR = 1;
                _that.DrawChartMultiple(_that.vhistory)
              }
              _that.loadDataCounter += 1
            }
            else {
              //if (_that.gn.user.driverid + '' == '-1' && _that.driverVehicles.length > 1) {
              // alert('@1'+(parseInt(_that.lastIdxVeh+'')-1)+'')
              // alert('@2'+_that.idxVeh+'')
              //if ((parseInt(_that.lastIdxVeh)-1)+'' == _that.idxVeh+'') {
              _that.loadHistoryMap(_that.myMapDiv, _that.actionPath, bounds, _that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicleDB)]], _that.vhistory)
              _that.loadDataCounter += 1
              //}
              //} else {
              //_that.loadHistoryMap(_that.mapElement.nativeElement, _that.actionPath, bounds, _that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicleDB)]], _that.vhistory)
              //}
              _that.loadSpinner = false
            }
            _that.probno()

            //mobile
            if ((<HTMLElement>document.getElementsByClassName('report-filter-mob')[0]).offsetHeight > 0) {
              //_that.chartDataOpened = false
            }
            //mobile
          })

        }
        _that.checkIfMapIsLoaded()
      })
    } else {
      this.loadingData = false
    }
  }

  probno() {
    this.gn.globalreportButtons = false

    var _that = this
    document.getElementById('mapHistory').addEventListener('mouseover', function (e) {
      var x = e.clientX
      var y = e.clientY
      var els = document.elementsFromPoint(x, y);
      els.reverse()
      var _html = ''
      var _html1 = ''
      var probnooo
      var el = document.createElement("DIV");
      var brojac = 0


      for (var i = 0; i < els.length; i++) {
        if (els[i].classList.contains('div-marker-rec')) {
          brojac++
          let elparent = <HTMLElement>els[i].parentNode;
          probnooo = elparent.outerHTML;
          // console.log(probnooo, 'daj da te vidam')
          if (els[i].getAttribute('titlekTow') != null) {
            _html += '<div style="z-index:1; position: relative; float:left; height:30px; top:-5px; margin-right:1px;"> ' + probnooo + ' </div>'
          } else {
            _html += '<div style="z-index:1; position: relative; float:left; height:30px; padding-top: 5px"> ' + probnooo + ' </div>'
            if (els[i].getAttribute('titleK1') != null)
              _html += els[i].getAttribute('titleK1')
          }

          if (els[i].getAttribute('titlek') != null)
            _html1 += els[i].getAttribute('titlek')

          if (els[i].getAttribute('titlekTow') != null)
            _html1 += els[i].getAttribute('titlekTow')
        }
        else {
          var el1 = document.getElementById('map-undermouse-popup')
          //console.log(el, 'daj da vidam el')
          if (el1 != null) {
            el1.setAttribute('gtimer', '0')
            // el.setAttribute('data', '')
            // el.setAttribute('nodeValue', '')
          }
        }

        // if (els[i].tagName.toLowerCase() == 'img') {
        //   // console.log(els[i].attributes[0].textContent, 'daj pobeda')
        //   let elparent = <HTMLElement>els[i].parentNode;
        //   var t = els[i].tagName.indexOf('pin-')
        //   if (t != -1) {
        //     debugger
        //   }
        //   // console.log(els[i].attributes.getNamedItem('pin-red-green.png'), 'daj da vidam dali ima pin-red-green.png list')
        //   // console.log(ch1[0].tagName.indexOf('pin-blue.png'))

        //   // if (els[i].contains('assets/imgs/pin-red-green.png')) {
        //   // }
        // }
        //   } else {
        //     var el = document.getElementById('map-undermouse-popup')
        //     if (el != null) {
        //       el.setAttribute('gtimer', '0')
        //     }
        // var el1 = document.getElementById('map-undermouse-popup')
        // //console.log(el, 'daj da vidam el')
        // if (el1 != null) {
        //   el1.setAttribute('gtimer', '0')
        //   // el.setAttribute('data', '')
        //   // el.setAttribute('nodeValue', '')
        // }

        // }
      }

      if (brojac > 1 && _html != '') {
        // console.log(brojac, _html)
        el.innerHTML = '@' + _html
        _that.showUnderMouse(el.innerHTML, _that.googleX - 80, _that.googleY - 160)
        //debugger
      }
      if (brojac == 1 && _html1 != '') {
        el.innerHTML = '@' + _html1
        _that.showUnderMouse(el.innerHTML, _that.googleX - 80, _that.googleY - 160)
      }

    })

  }

  getPriv(key) {
    if (this.gn.priv.length == 0)
      return true;
    var num;
    for (var i = 0; i < this.gn.priv.length; i++) {
      if (this.gn.user.RoleId == 3) {
        if (this.gn.user.UserId == this.gn.priv[i].userid) {
          return this.gn.priv[i][key];
        }
      } else {
        return true;
      }
    }
  }

  Round(_txt) {
    return parseInt(_txt + '')
  }

  loadHistoryMap(mapElement, actionPath, bounds, vehicle, vhis) {
    // console.log(document.getElementById('mapHistory'))
    // this._speed = []
    this.path = [];
    this.pathBuzzer = [];
    this.vhis = vhis;
    this.motorOff = [];
    // console.log('dali seriozno si tuka')
    //debugger;

    var _that = this;
    if (this.checkR == 0) {
      let mapOptions1 = {
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.LEFT_TOP,
          mapTypeIds: [
            google.maps.MapTypeId.ROADMAP,
            google.maps.MapTypeId.HYBRID
          ]
        },
        zoomControl: true,
        scaleControl: false,
        fullscreenControl: false,
        streetViewControl: false,
      }

      if (this.historyMap == undefined) {
        if (_that.myMapDiv == null) { _that.createMapElement() }
        this.historyMap = new google.maps.Map(_that.myMapDiv, mapOptions1);
        // window["PanoramaHistoryMap"] = _that.historyMap
        _that.myMapDiv.addEventListener("mousemove", function (e) {
          _that.googleX = e.screenX - 50
          _that.googleY = e.screenY
        });

        google.maps.event.trigger(this.historyMap, "resize");
        google.maps.event.addListener(this.historyMap, 'dblclick', function (evn) {
          console.log('dali dbclickclick')

          // console.log('tukaaa 123')
          // console.log(_that.MapSelectedButton)
          if (_that.MapSelectedButton == 'ADDZONE') {

            //evn.stopPropagation()                
            // _that.openModalAddZone()
            evn.preventDefault()

          }
        });
        google.maps.event.addListener(this.historyMap, 'click', function (evn) {
          console.log('dali tttttt')
          // console.log(evn.target)
          var _lon = evn.latLng.lng()
          var _lat = evn.latLng.lat()
          // if (gn.live.inAddPOI == true) {
          //   gn.live.OpenAddMarkerWindow(_lon, _lat)
          // }
          // console.log(this.MapSelectedButton)
          if (_that.MapSelectedButton == 'ADDZONE') {
            _that.newZonePoints.push({ lon: _lon, lat: _lat })
            _that.drawNewZone()
          }
          if (_that.MapSelectedButton == 'ADDPOI') {
            _that.openModalAddPoi(_lat, _lon)
          }
          if (_that.ContextMenu != undefined)
            _that.HideContextMenuGoolge(_that.ContextMenu);
        });

        google.maps.event.addListener(this.historyMap, 'rightclick', function (evn) {
          if (_that.gn.clientsettings.clienttypeid + '' == '18' || _that.gn.clientsettings.allowedrouting == '0') {
            return false
          }
          if (_that.popovertemp != undefined) {
            _that.popovertemp.dismiss()
            _that.popovertemp = undefined;
            _that.ClearLine()
          }
          _that.gn.Socket.emit({ lon: evn.latLng.lng(), lat: evn.latLng.lat() }, function (_data) {
            console.log('dali vleguvas tuka aaaaa')
            _that._copyAddress = _data.address
            _that.ContextMenu = document.getElementById("my-context-menu");
            _that.ShowContextMenuGoolge(_that.ContextMenu, evn);
            _that._copyCoords = [evn.latLng.lng(), evn.latLng.lat()]
            /** this stop NOT stopping DOM 'context-menu' event from firing */
            evn.stop();
          }, 'getreversegeocode')

        });
      }
    }
    // google.maps.Map.prototype.panToWithOffset = function (latlng, offsetX, offsetY) {
    //   var map = this;
    //   var ov = new google.maps.OverlayView();
    //   ov.onAdd = function () {
    //     var proj = this.getProjection();
    //     var aPoint = proj.fromLatLngToContainerPixel(latlng);
    //     aPoint.x = aPoint.x + offsetX;
    //     aPoint.y = aPoint.y + offsetY;
    //     map.panTo(proj.fromContainerPixelToLatLng(aPoint));
    //   };
    //   ov.draw = function () { };
    //   ov.setMap(this);
    // };
    var latLng
    // debugger
    if (_that.recData.length != 0) {

      latLng = new google.maps.LatLng(_that.recData[0].lat, _that.recData[0].lon)

      // this.historyMarker = this.addMarker(vehicle);
      // this.historyMarker.setMap(this.historyMap);
      // this.addMarker(vehicle);


      var idx = 0

      if (_that.vhis + "" == "0") {
        _that.maxSpeedRec.push({ speed: _that.recData[0].speed, dt: moment(_that.recData[0].datetime) })
      }
      if (_that.vhis + "" == "1") {
        _that.maxSpeedRec2.push({ speed: _that.recData[0].speed, dt: moment(_that.recData[0].datetime) })
      }
      if (_that.vhis + "" == "2") {
        _that.maxSpeedRec3.push({ speed: _that.recData[0].speed, dt: moment(_that.recData[0].datetime) })
      }

      var _lastValidSpeedLimit = -1;
      _that.recData.forEach(element => {
        if (_that.isIdleRep)
          _that.idleObj = element;

        var point = {
          lat: parseFloat(element.lat),
          lng: parseFloat(element.lon)
        }

        if (_that.vhis + "" == "0") {
          if (parseInt(element.speed) > parseInt(_that.maxSpeedRec[0].speed)) {
            _that.maxSpeedRec[0].speed = element.speed;
            _that.maxSpeedRec[0].dt = moment(element.datetime);
          }
        }
        if (_that.vhis + "" == "1") {
          if (parseInt(element.speed) > parseInt(_that.maxSpeedRec2[0].speed)) {
            _that.maxSpeedRec2[0].speed = element.speed;
            _that.maxSpeedRec2[0].dt = moment(element.datetime);
          }
        }
        if (_that.vhis + "" == "2") {
          if (parseInt(element.speed) > parseInt(_that.maxSpeedRec3[0].speed)) {
            _that.maxSpeedRec3[0].speed = element.speed;
            _that.maxSpeedRec3[0].dt = moment(element.datetime);
          }
        }




        //canbus fuel
        //if (parseFloat(element.cbfuel) > 2) {
        if (_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].alcanbas + '' == '1') {

          if (idx == 0 || idx == _that.recData.length - 1) {
            _that.Odometer.push(parseFloat(element.cbdistance))
          } else {
            _that.Odometer.push(null)
          }

          if (_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].a_cbf + '' == '1')
            _that.HaveFuel = true

          _that.HaveOdometer = true
          // alert(1)

          if (_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].a_cbf + '' == '1') {
            if (parseInt(element.cbfuel, 10) != 0) {
              _that.Fuel.push(parseFloat(element.cbfuel))
              _that.checkForFuelDownNow = parseFloat(element.cbfuel);
              if (element.speed <= 5 && _that.checkForFuelDown == -1) {
                _that.checkForFuelDown = parseFloat(element.cbfuel);
                _that.checkForFuelDownDt = element.datetime;
              } else {
                if (element.speed > 5) {
                  _that.checkForFuelDown = -1;
                  _that.checkForFuelDownDt = '';
                }
              }
            } else {
              if (idx != 0) {
                if (parseFloat(element.cbfuel) == 0) {
                  _that.Fuel.push(parseFloat(_that.Fuel[idx - 1]))
                  _that.checkForFuelDownNow = parseFloat(_that.Fuel[idx - 1]);
                }
                if (element.speed <= 5 && _that.checkForFuelDown == -1) {
                  _that.checkForFuelDown = parseFloat(_that.Fuel[idx - 1]);
                  _that.checkForFuelDownDt = element.datetime;
                } else {
                  if (element.speed > 5) {
                    _that.checkForFuelDown = -1;
                    _that.checkForFuelDownDt = '';
                  }
                }
              }
            }
          }
        }

        if (_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].alcanbas + '' == '0' || (_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].alcanbas + '' == '1' && _that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].a_cbf + '' == '0')) {
          //ultrasonic fuel
          if (_that.gn.Vehicles[_that.gn.VehiclesDic[parseInt(_that.vehicles[0])]].allowultrasonic + '' == '1') {
            _that.HaveFuel = true
            _that.Fuel.push(Math.round(element.fuel))
            _that.checkForFuelDownNow = Math.round(element.fuel);
            if (element.speed <= 5 && _that.checkForFuelDown == -1) {
              _that.checkForFuelDown = Math.round(element.fuel);
              _that.checkForFuelDownDt = element.datetime;
            } else {
              if (element.speed > 5) {
                _that.checkForFuelDown = -1;
                _that.checkForFuelDownDt = '';
              }
            }
          } else {
            //debugger
            //fuel by equation
            if (element.col5 != null) {
              // alert(element.col5)
              _that.HaveFuel = true
              _that.Fuel.push(Math.round(element.col5));
              _that.checkForFuelDownNow = Math.round(element.col5);
              if (element.speed <= 5 && _that.checkForFuelDown == -1 && _that.checkForFuelDownNow >= 0) {
                _that.checkForFuelDown = Math.round(element.col5);
                _that.checkForFuelDownDt = element.datetime;
              } else {
                if (element.speed > 5) {
                  _that.checkForFuelDown = -1;
                  _that.checkForFuelDownDt = '';
                }
              }
            }
          }
        }
        //_that.repfuelDownDt == undefined ako e od rekonstrukcija, a ne od lupata od izvestajot somnitelni padovi
        if (_that.checkForFuelDownDt != '' && _that.repfuelDownDt == undefined) {
          var start = moment(_that.checkForFuelDownDt, "YYYY-MM-DD HH:mm:ss");
          var end = moment(element.datetime, "YYYY-MM-DD HH:mm:ss");
          var _diffmin = moment.duration(end.diff(start)).asMinutes();
          //console.log('FUEL DOWN #', element.datetime, element.di1, element.speed, _that.checkForFuelDownDt, _diffmin, _that.checkForFuelDownNow - _that.checkForFuelDown)

          if (_diffmin >= 6 && (_that.checkForFuelDown - _that.checkForFuelDownNow) > 10) {
            _that.fuelDown.push({ dt: moment(element.datetime) })
            //console.log('FUEL DOWN #### ' + element.datetime + ' ' + _that.checkForFuelDownDt + ': ' + _that.checkForFuelDown + ' ' + _that.checkForFuelDownNow + ' ' + (_that.checkForFuelDown - _that.checkForFuelDownNow))
            _that.checkForFuelDown = -1;
            _that.checkForFuelDownDt = '';

          } else {
            if (_diffmin >= 6 && (_that.checkForFuelDown - _that.checkForFuelDownNow) <= 10) {
              _that.checkForFuelDown = -1;
              _that.checkForFuelDownDt = '';
            }
          }
        }


        // var spd = (element.speed+'').replace('NaN','').replace('mph','').replace('Km/h', "").replace('/', "0")

        _that.path.push(point)
        _that.pathBuzzer.push(point)

        if (vhis == "0") {
          _that._speed.push(parseInt(element.speed + ''))

          if (parseInt(element.col7) > -1) {
            _that._speedLimit.push(parseInt(element.col7 + ''))
            _lastValidSpeedLimit = element.col7
          } else {
            if (_lastValidSpeedLimit == -1) _lastValidSpeedLimit = element.speed
            _that._speedLimit.push(parseInt(_lastValidSpeedLimit + ''))
          }

          _that._dt.push(moment(element.datetime).toDate())
          _that._ign.push(parseInt(element.di1 + ''))
        }
        if (vhis == "1") {
          _that._speed2.push(parseInt(element.speed + ''))
          _that._dt2.push(moment(element.datetime).toDate())
          _that._ign2.push(parseInt(element.di1 + ''))
        }
        if (vhis == "2") {
          _that._speed3.push(parseInt(element.speed + ''))
          _that._dt3.push(moment(element.datetime).toDate())
          _that._ign3.push(parseInt(element.di1 + ''))
        }

        if (idx == 0) {
          _that.motorOff.push(element.lat + '|' + element.lon)
        }
        if (element.di1 + '' == '0') {
          if (_that.motorOff.indexOf(element.lat + '|' + element.lon) == -1) {
            _that.motorOff.push(element.lat + '|' + element.lon)
          }
        }
        if (idx == _that.recData.length - 1) {
          // this.motorOff.push(element.lat+'|'+element.lon)
          if (_that.motorOff.indexOf(element.lat + '|' + element.lon) == -1) {
            _that.motorOff.push(element.lat + '|' + element.lon)
          }
        }
        // _timestamp.push()
        idx = idx + 1
      });
      //debugger;
      this.addMarker(vehicle, parseFloat(this.path[0].lat), parseFloat(this.path[0].lng));
      // var lineSymbol = {
      //   path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW,
      //   // strokeWeight: 1,
      //   // strokeColor: '#292'
      // };
      var lineSymbol = {
        //path: 'M -1.3,-3 0,0 1.3,-3 z',
        path: 'M -1.3,3 0,0 1.3,3 0,2.5 z',
        strokeColor: '#fff',
        fillColor: this.lineColors1[this.vhis % 10],
        fillOpacity: 1,
        strokeWeight: 1
      };

      var lineSymbolArrow = {
        //path: 'M -1.3,-3 0,0 1.3,-3 z',
        path: 'M -1.3,3 0,0 1.3,3 0,2.5 z',
        strokeColor: '#fff',
        fillColor: '#0059b3',
        fillOpacity: 1,
        strokeWeight: 1
      };

      // if (this.flightPath != null) {
      //   this.flightPath.setMap(null)
      //   this.flightPath = null
      // }

      //novo 26 Jan

      if (this.vehicles.length == 1 && this.gn.Vehicles[this.gn.VehiclesDic[this.vehicles[0]]].speedlimitalertallow + '' == '1') {

        //crna podebela linija
        var flightPath_ = new google.maps.Polyline({
          path: this.path,
          geodesic: true,
          strokeColor: 'black',
          strokeOpacity: 1.0,
          strokeWeight: 5,
          zIndex: 1
        });

        flightPath_.setMap(this.historyMap);
        this.Traektorii.push(flightPath_)
        //end crna podebela linija


        //
        var _that = this
        this.gn._Post('/api/gn/reports/getadminspeedlimitbuzzerpath', {}, function (_data) {
          _that._adminbuzzpath = _data.data
          for (var p = 0; p < _that.path.length; p++) {

            //var isalertSpeedLimit = false
            var _percentspeedlimit = 0
            // if (_that._speedLimit[p] > -1 && _that._speed[p] > _that._speedLimit[p]) {
            //   isalertSpeedLimit = true
            // }
            //17jan (1) orka

            if (_that._speedLimit[p] > 0)
              _percentspeedlimit = (_that._speed[p] - _that._speedLimit[p]) / _that._speedLimit[p] * 100
            else
              _percentspeedlimit = 0

            var _colorPath = ''
            // if (_percentspeedlimit <= -20) _colorPath = '#2eee14'
            // if (_percentspeedlimit > -20 && _percentspeedlimit <= 0) _colorPath = '#00b0fe'
            // if (_percentspeedlimit > 0 && _percentspeedlimit <= 20) _colorPath = '#ffff00'
            // if (_percentspeedlimit > 20 && _percentspeedlimit <= 30) _colorPath = '#ffad00'
            // if (_percentspeedlimit > 30) _colorPath = '#ff0000'

            //  if (_percentspeedlimit < 1) _colorPath = '#2eee14'
            // if (_percentspeedlimit >= 1 && _percentspeedlimit < 10) _colorPath = '#00b0fe'
            // if (_percentspeedlimit >= 10 && _percentspeedlimit < 20) _colorPath = '#ffff00'
            // if (_percentspeedlimit >= 20 && _percentspeedlimit < 30) _colorPath = '#ffad00'
            // if (_percentspeedlimit >= 30) _colorPath = '#ff0000'

            if (_percentspeedlimit < _that._adminbuzzpath[0].speedlimit12percent) _colorPath = _that._adminbuzzpath[0].speedlimit1color//'#2eee14'
            if (_percentspeedlimit >= _that._adminbuzzpath[0].speedlimit12percent && _percentspeedlimit < _that._adminbuzzpath[0].speedlimit23percent) _colorPath = _that._adminbuzzpath[0].speedlimit2color//'#00b0fe'
            if (_percentspeedlimit >= _that._adminbuzzpath[0].speedlimit23percent && _percentspeedlimit < _that._adminbuzzpath[0].speedlimit34percent) _colorPath = _that._adminbuzzpath[0].speedlimit3color//'#ffff00'
            if (_percentspeedlimit >= _that._adminbuzzpath[0].speedlimit34percent && _percentspeedlimit < _that._adminbuzzpath[0].speedlimit45percent) _colorPath = _that._adminbuzzpath[0].speedlimit4color//'#ffad00'
            if (_percentspeedlimit >= _that._adminbuzzpath[0].speedlimit45percent) _colorPath = _that._adminbuzzpath[0].speedlimit5color//'#ff0000'

            var flightPath = new google.maps.Polyline({
              path: [_that.path[p], _that.path[p + 1]],
              geodesic: true,
              strokeColor: _colorPath,
              strokeOpacity: 1.0,
              strokeWeight: 4,
              zIndex: 2
            });

            flightPath.setMap(_that.historyMap);
            _that.Traektorii.push(flightPath)
          }

        })



        //za strelkite so sarena linija
        var flightPath = new google.maps.Polyline({
          path: this.path,
          geodesic: true,
          strokeColor: 'transparent',
          strokeOpacity: 1.0,
          strokeWeight: 5,
          icons: [
            { icon: lineSymbolArrow, offset: '10%' },
            { icon: lineSymbolArrow, offset: '20%' },
            { icon: lineSymbolArrow, offset: '30%' },
            { icon: lineSymbolArrow, offset: '40%' },
            { icon: lineSymbolArrow, offset: '50%' },
            { icon: lineSymbolArrow, offset: '60%' },
            { icon: lineSymbolArrow, offset: '70%' },
            { icon: lineSymbolArrow, offset: '80%' },
            { icon: lineSymbolArrow, offset: '90%' },
          ],
          zIndex: 3
        });

        flightPath.setMap(this.historyMap);
        this.Traektorii.push(flightPath)
        //end za strelkite so sarena linija

      } else {
        var flightPath = new google.maps.Polyline({
          path: this.path,
          geodesic: true,
          strokeColor: this.lineColors[this.vhis % 10],
          strokeOpacity: 1.0,
          strokeWeight: 5,
          icons: [
            { icon: lineSymbol, offset: '10%' },
            { icon: lineSymbol, offset: '20%' },
            { icon: lineSymbol, offset: '30%' },
            { icon: lineSymbol, offset: '40%' },
            { icon: lineSymbol, offset: '50%' },
            { icon: lineSymbol, offset: '60%' },
            { icon: lineSymbol, offset: '70%' },
            { icon: lineSymbol, offset: '80%' },
            { icon: lineSymbol, offset: '90%' },
          ]
        });

        flightPath.setMap(this.historyMap);
        this.Traektorii.push(flightPath)
      }





      // var flightPath1 = new google.maps.Polyline({
      //   path: this.pathBuzzer,
      //   geodesic: true,
      //   strokeColor: this.lineColors[3 % 10],
      //   strokeOpacity: 1.0,
      //   strokeWeight: 2,
      //   icons: [
      //     { icon: lineSymbol, offset: '10%' },
      //     { icon: lineSymbol, offset: '20%' },
      //     { icon: lineSymbol, offset: '30%' },
      //     { icon: lineSymbol, offset: '40%' },
      //     { icon: lineSymbol, offset: '50%' },
      //     { icon: lineSymbol, offset: '60%' },
      //     { icon: lineSymbol, offset: '70%' },
      //     { icon: lineSymbol, offset: '80%' },
      //     { icon: lineSymbol, offset: '90%' },
      //   ]
      // });

      // flightPath1.setMap(this.historyMap);
      // this.Traektorii.push(flightPath1)


      if (this.historyMap != undefined) {
        this.historyMap.fitBounds(bounds);      //auto-zoom
        this.historyMap.panToBounds(bounds); //auto-cente
      }
      this.drawPolygone()

      var _distSE = this.distance(this.motorOff[0].split('|')[0], this.motorOff[0].split('|')[1], this.motorOff[this.motorOff.length - 1].split('|')[0], this.motorOff[this.motorOff.length - 1].split('|')[1])
      var _len = this.motorOff.length
      var _same = false;
      if (parseInt(_distSE + '') < 50) {
        _len = _len - 1;
        //_same = true;
      }
      //i=1, bez startpoint
      for (var i = 1; i < _len; i++) {
        var ll = _that.motorOff[i].split('|')
        var clr = 'blue'
        if (i == 0) {
          clr = 'green'
          _that.addSartEndMarkerHistoryMap(ll[0], ll[1], clr, i + '', _same, _that.idleObj)
          _same = false;
        }
        if (i == _that.motorOff.length - 1) {
          clr = 'red'
          _that.addSartEndMarkerHistoryMap(ll[0], ll[1], clr, i + '', _same, _that.idleObj)
          _same = false;
        }

      }

      //startpoint
      ll = _that.motorOff[0].split('|')
      clr = 'green'
      if (parseInt(_distSE + '') < 50) {
        _same = true;
      }
      _that.addSartEndMarkerHistoryMap(ll[0], ll[1], clr, '0', _same, _that.idleObj)
      //startpoint
      // _that.addSartEndMarkerHistoryMap(_that.recData[0].lat, _that.recData[0].lon, 'green', 'S')
      // _that.addSartEndMarkerHistoryMap(_that.recData[_that.recData.length - 1].lat, _that.recData[_that.recData.length - 1].lon, 'red', 'E')
      // setTimeout(function () {
      //   _that.drawChart(_that._speed, _that._dt)
      // }, 200)
      //debugger
      if (_that.gn.user.driverid + '' == '-1' && _that.vehicles.length > 1) {
        _that.DrawChartMultiple(vhis)
      } else {
        if (!this.isIdleRep && vhis == 0 && _that.vehicles.length == 1) {
          _that.DrawChart()
          _that.graphTmp = true;
        }
      }


      // _that.historyMap.panToWithOffset(_that.historyMap.getCenter(), 0, 200);
    }
    else {
      // debugger
      // if (_that.gn.user.driverid + '' == '-1' && _that.vehicles.length > 1) {
      //   _that.DrawChartMultiple(vhis)
      // }

    }
    this.checkR = 1;

  }


  checkIfMapIsLoaded() {
    // _that.loadDataCounter = 0
    // for (var v = 0; v < _dataV.data.length; v++) {
    // console.log(this.loadDataCounter, this.loadDataCounterMax)
    var _that = this
    if (this.loadDataCounter != this.loadDataCounterMax) {
      // _that.checkIfMapIsLoaded
      setTimeout(function () {
        _that.checkIfMapIsLoaded()
      }, 100)
      return
    }
    // Mapata tuka bi trebalo da e inicijalizirana

    setTimeout(function () {
      _that.checkIfMapIsLoaded2()
    }, 500)
  }
  checkIfMapIsLoaded2() {
    var _that = this
    try {
      var tmpEl = document.getElementsByClassName('tmpMapGoranDiv')[0].querySelectorAll('.gmnoprint').length
      if (tmpEl == 0) {
        console.log('Mapata NE se VCITA - 1')
        setTimeout(function () {
          var tmpEl2 = document.getElementsByClassName('tmpMapGoranDiv')[0].querySelectorAll('.gmnoprint').length
          if (tmpEl2 == 0) {
            console.log('Mapata NE se VCITA - 2')
            _that.resetVariables()
            _that.loadData()
          } else {
            console.log('Mapata se VCITA')
          }
        }, 500)

      } else {
        console.log('Mapata se VCITA')
      }
    } catch (error) {
      setTimeout(function () {
        _that.checkIfMapIsLoaded2()
      }, 100)
    }
  }

  addMarker(v, lat, lng) {
    //sofer, bidejki nema grafik
    if (this.gn.user.driverid + '' != '-1') {
      v.color = 'Red'
    }
    if (this.isIdleRep) {
      setTimeout(() => {
        this.historyMap.setZoom(this.historyMap.getZoom() - 5)
      }, 100);
      v.color = 'Green';
    } else {
      var el = document.createElement("DIV");
      el.className = "gn-ol-market" + this.gn.user.vehsize + " gn-car-" + v.color
      el.innerHTML = '<span style="z-index:1; position: relative">' + v.code + '</span><span class="gn-nouse' + this.gn.user.vehsize + '"></span>'
      el.setAttribute('car-code', v.code)
      if (this.gn.user.driverid + '' == '-1') {
        el.setAttribute('id', 'gncar-rec-' + v.code)
      }
      this.historyMarker = new RichMarker({
        position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
        map: this.historyMap,
        draggable: false,
        content: el.outerHTML,
        anchor: RichMarkerPosition.MIDDLE
      });
      this.historyMarkerMultiple[v.vehicleid] = this.historyMarker
      // debugger
      // if (this.isIdleRep) {
      //   setTimeout(() => {
      //     this.historyMap.setZoom(this.historyMap.getZoom() - 5)
      //   }, 100);
      // }

      // return marker
      // this.gn.VehicleAnim.push()
      // this.gn.VehicleAnim.push({ code: v.code, lon: v.latitude, lat: v.longitude, marker: marker, anim: [] })
    }
  }


  // getCoordinates(x, y, lat, lng) {
  //   var degreesPerPixelX = 360 / Math.pow(2, parseInt(this.historyMap.getZoom()) + 8);
  //   var degreesPerPixelY = 360 / Math.pow(2, parseInt(this.historyMap.getZoom()) + 8) * Math.cos(parseFloat(lat) * Math.PI / 180);

  //   return {
  //     lat: parseFloat(lat) - degreesPerPixelY * (parseFloat(y) - 0 / 2),
  //     lng: parseFloat(lng) + degreesPerPixelX * (parseFloat(x) - 0 / 2),
  //   }
  // }

  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  addSartEndMarkerHistoryMap(lat, lng, iconUrl, lbl, same, obj) {
    // var lbl = 'P'

    if (this.isIdleRep) same = false;

    if (same + '' == 'true') {
      var _that = this
      // setTimeout(function () {
      var imageVar = 'assets/imgs/newpin-red-green1.png'; //lbl = '.'

      //lat = _that.getCoordinates(0, 0, lat, lng).lat;///42.050946770560;;//lat;//
      //lng = _that.getCoordinates(0, 0, lat, lng).lng;
      // var markerIcon = {
      //   url: img,
      //   scaledSize: new google.maps.Size(49.5, 43),
      //   origin: new google.maps.Point(0, 0),
      //   anchor: new google.maps.Point(25, 43),
      //   labelOrigin: new google.maps.Point(24, 15)
      // };
      // var marker = new google.maps.Marker({
      //   position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
      //   map: _that.historyMap,
      //   icon: markerIcon//,
      //   // label: {
      //   //   //text: '<span style="padding-top:10px">START</span>',
      //   //   text: '',
      //   //   color: "#fff",
      //   //   fontSize: "14px",
      //   //   fontWeight: "bold",
      //   // }
      // });
      var el = document.createElement("div");
      el.className = 'div-marker-rec'
      //el.className = "gn-ol-market" + this.gn.user.vehsize + " gn-car-"
      el.innerHTML = '<img src="' + imageVar + '" style="width:43px; height:43px; position:relative; top:-11px;"/>'
      //el.setAttribute('car-code', lbl)
      //el.setAttribute('id', 'gncar-' + lbl)
      // console.log(parseFloat(lat), parseFloat(lng), 'daj ova da vidam da ne e prob')

      this.pinMarker = new RichMarker({
        position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
        map: this.historyMap,
        draggable: false,
        content: el.outerHTML,
        anchor: RichMarkerPosition.MIDDLE,
        // ready_: true
      });
      this.pinMarkers.push(this.pinMarker)


      //start buzzer icon
      if (this.buzzerdt != '2000-01-01' && this.buzzerdt != undefined && this.gn.Vehicles[this.gn.VehiclesDic[parseInt(this.vehicles[0])]].speedlimitalertallow + '' == '1') {
        var elBuzz = document.createElement("div");
        elBuzz.className = 'div-marker-buzzer'
        elBuzz.innerHTML = '<div style="position:relative; top:-4px; left:6px"><img src="assets/imgs/buzzer.png" style="width:38px; height:43px;"/><div style="color: #000; font-size:14px; font-weight:bold; position:relative; width: 23px; text-align:center;"> </div></div>'

        var markerBuzz = new RichMarker({
          position: new google.maps.LatLng(parseFloat(this.buzzerlat), parseFloat(this.buzzerlon)),
          map: this.historyMap,
          draggable: false,
          content: elBuzz.outerHTML,
          anchor: RichMarkerPosition.MIDDLE
        });

        this.seMarkers.push(markerBuzz)
      }
      //end buzzer icon

      //START REFILL ICON
      // var elRefill = document.createElement("div");
      // elRefill.className = 'div-marker-refill'
      // var _txtRefill = 'Дотур 50 lit во 11:12:40'
      // elRefill.innerHTML = '<div title="' + _txtRefill + '" style="position:relative; top:-4px; left:6px"><img src="assets/imgs/refill1.png" style="width:38px; height:43px;"/><div style="color: #000; font-size:14px; font-weight:bold; position:relative; width: 23px; text-align:center;"> </div></div>'

      // var markerRefill = new RichMarker({
      //   position: new google.maps.LatLng(parseFloat('41.834403'), parseFloat('22.030650')),
      //   map: this.historyMap,
      //   draggable: false,
      //   content: elRefill.outerHTML,
      //   anchor: RichMarkerPosition.MIDDLE
      // });

      // this.seMarkers.push(markerRefill)
      //END REFILL ICON

      // })
    }
    else {
      var img = 'assets/imgs/newpin-blue.png'
      var imageVar = 'assets/imgs/newpin-blue.png'
      if (!this.isIdleRep) {
        var top = '-41'
        if (iconUrl == 'green') { img = 'assets/imgs/newpin-green.png'; lbl = 'S'; imageVar = 'assets/imgs/newpin-green.png' }
        if (iconUrl == 'red') { img = 'assets/imgs/newpin-red.png'; lbl = 'E'; imageVar = 'assets/imgs/newpin-red.png' }
        var title = ''
        var titleMultiple = ''
        if (iconUrl == 'idleengineon') {
          title = '<div style="font-size:12px"><div style="text-transform: uppercase; color: #f68c3a; font-weight: bold">' + this.dic.l["idleengineon"] + '</div><div>' + this.dic.l["startidle"] + ': <b>' + moment(obj.startdatetime).format(this.gn.user.TFormat) + '</b></div><div>' + this.dic.l["endidle"] + ': <b>' + moment(obj.enddatetime).format(this.gn.user.TFormat) + '</b></div><div>' + this.dic.l["totaltimeidleengineon"] + ': <b>' + this.sec2str2(obj.timediff) + '</b></div></div>'
          titleMultiple = '<div style="font-size:12px"><div style="text-transform: uppercase; color: #f68c3a; font-weight: bold">' + this.dic.l["idleengineon"] + '</div><div style="padding-left:38px">' + this.dic.l["startidle"] + ': <b>' + moment(obj.startdatetime).format(this.gn.user.TFormat) + '</b></div><div style="padding-left:38px">' + this.dic.l["endidle"] + ': <b>' + moment(obj.enddatetime).format(this.gn.user.TFormat) + '</b></div><div style="padding-left:38px">' + this.dic.l["totaltimeidleengineon"] + ': <b>' + this.sec2str2(obj.timediff) + '</b></div></div>'
          top = '-42'; img = 'assets/imgs/newpin-orange-rec1.png'; lbl = lbl; imageVar = 'assets/imgs/newpin-orange-rec1.png'
        }
        if (iconUrl == 'idleengineoff') {
          title = '<div style="font-size:12px"><div style="text-transform: uppercase; color: #1855a0; font-weight: bold">' + this.dic.l["idleengineoff"] + '</div><div>' + this.dic.l["startidle"] + ': <b>' + moment(obj.startdatetime).format(this.gn.user.TFormat) + '</b></div><div>' + this.dic.l["endidle"] + ': <b>' + moment(obj.enddatetime).format(this.gn.user.TFormat) + '</b></div><div>' + this.dic.l["totaltimeidleengineoff"] + ': <b>' + this.sec2str2(obj.timediff) + '</b></div></div>'
          titleMultiple = '<div style="font-size:12px"><div style="text-transform: uppercase; color: #1855a0; font-weight: bold">' + this.dic.l["idleengineoff"] + '</div><div style="padding-left:38px">' + this.dic.l["startidle"] + ': <b>' + moment(obj.startdatetime).format(this.gn.user.TFormat) + '</b></div><div style="padding-left:38px">' + this.dic.l["endidle"] + ': <b>' + moment(obj.enddatetime).format(this.gn.user.TFormat) + '</b></div><div style="padding-left:38px">' + this.dic.l["totaltimeidleengineoff"] + ': <b>' + this.sec2str2(obj.timediff) + '</b></div></div>'
          top = '-42'; img = 'assets/imgs/newpin-blue-rec1.png'; lbl = lbl; imageVar = 'assets/imgs/newpin-blue-rec1.png'
        }
        if (iconUrl == 'tow0') {
          title = '<div style="font-size:12px"><div style="text-transform: uppercase; color: #f53d3d; font-weight: bold">Подигање во обид</div><div>Време: <b>' + moment(obj.dt).format(this.gn.user.TFormat) + '</b></div></div>'
          top = '-33'; img = 'assets/imgs/pajak-red.png'; lbl = ''; imageVar = 'assets/imgs/pajak-red.png'
        }
        if (iconUrl == 'tow1') {
          title = '<div style="font-size:12px"><div style="text-transform: uppercase; color: #54d469; font-weight: bold">Подигање по процедура</div><div>Време: <b>' + moment(obj.dt).format(this.gn.user.TFormat) + '</b></div></div>'
          top = '-33'; img = 'assets/imgs/pajak-green.png'; lbl = lbl; imageVar = 'assets/imgs/pajak-green.png'
        }

        // var markerIcon = {
        //   url: img,
        //   scaledSize: new google.maps.Size(27, 43),
        //   origin: new google.maps.Point(0, 0),
        //   anchor: new google.maps.Point(14, 43),
        //   labelOrigin: new google.maps.Point(13, 15)
        // };

        // var marker = new google.maps.Marker({
        //   position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
        //   map: this.historyMap,
        //   icon: markerIcon,
        //   label: {
        //     text: lbl,
        //     color: "#fff",
        //     fontSize: "14px",
        //     fontWeight: "bold",
        //   }
        // });

        var el = document.createElement("div");
        el.className = 'div-marker-rec'

        //el.className = "gn-ol-market" + this.gn.user.vehsize + " gn-car-"
        if (iconUrl == 'tow0' || iconUrl == 'tow1') {
          el.setAttribute('titleKTow', title);
          el.innerHTML = '<div style="position:relative; top:5px"><img src="' + imageVar + '" style="width:43px; height:27px;"/></div>'
        } else {
          el.setAttribute('titleK', title);
          el.setAttribute('titleK1', titleMultiple);
          el.innerHTML = '<div style="position:relative; top:-11px"><img src="' + imageVar + '" style="width:38px; height:43px;"/><div style="color: #000; font-size:14px; font-weight:bold; position:relative; width: 23px; text-align:center; top:' + top + 'px; left:2px">' + lbl + '</div></div>'
        }
        //el.setAttribute('car-code', lbl)
        //el.setAttribute('id', 'gncar-' + lbl)
        var marker = new RichMarker({
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          map: this.historyMap,
          draggable: false,
          content: el.outerHTML,
          anchor: RichMarkerPosition.MIDDLE
        });
        this.seMarkers.push(marker)


        //start buzzer icon
        if (this.buzzerdt != '2000-01-01' && this.buzzerdt != undefined && this.gn.Vehicles[this.gn.VehiclesDic[parseInt(this.vehicles[0])]].speedlimitalertallow + '' == '1') {
          var elBuzz = document.createElement("div");
          elBuzz.className = 'div-marker-buzzer'
          elBuzz.innerHTML = '<div style="position:relative; top:-4px; left:6px"><img src="assets/imgs/buzzer.png" style="width:38px; height:43px;"/><div style="color: #000; font-size:14px; font-weight:bold; position:relative; width: 23px; text-align:center;"> </div></div>'

          var markerBuzz = new RichMarker({
            position: new google.maps.LatLng(parseFloat(this.buzzerlat), parseFloat(this.buzzerlon)),
            map: this.historyMap,
            draggable: false,
            content: elBuzz.outerHTML,
            anchor: RichMarkerPosition.MIDDLE
          });

          this.seMarkers.push(markerBuzz)
        }
        //end buzzer icon


        if (iconUrl == 'idleengineon' || iconUrl == 'idleengineoff') {
          this.allStops.push(marker)
        }
        if (iconUrl == 'tow0' || iconUrl == 'tow1') {
          this.allTowUps.push(marker)
        }
      } else {
        var img = 'assets/imgs/newpin-blue.png'
        lbl = ''

        var infowindow = new google.maps.InfoWindow();

        var markerIcon = {
          url: img,
          // scaledSize: new google.maps.Size(43, 43),
          // origin: new google.maps.Point(0, 0),
          // anchor: new google.maps.Point(22, 43),
          // labelOrigin: new google.maps.Point(13, 15)
          scaledSize: new google.maps.Size(38, 43),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(13, 43),
          labelOrigin: new google.maps.Point(13, 13)
        };

        /*done*/var marker = new google.maps.Marker({
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          map: this.historyMap,
          icon: markerIcon,
          label: {
            //text: lbl,
            color: "#000",
            fontSize: "14px",
            fontWeight: "bold",
          }
        });
        this.seMarkers.push(marker)

        var _that = this;
        google.maps.event.addListener(marker, 'click', function () {
          var _htmlInfo = `
          <table style="max-width:200px">
            <tr>
              <td class="info01">`+ _that.gn.dic.l["vehicle"] + `:</td>
              <td class="info02">`+ _that.gn.Vehicles[_that.gn.VehiclesDic[_that.vehicles[0]]].registration + `</td>
            </tr>
            <tr>
              <td class="info01">`+ _that.gn.dic.l["Date"] + `:</td>
              <td class="info02">`+ moment(obj.datetime).format(_that.gn.user.DFormat) + `</td>
            </tr>
            <tr>
              <td class="info01">`+ _that.gn.dic.l["Time"] + `:</td>
              <td class="info02">`+ moment(obj.datetime).format(_that.gn.user.TFormat) + `</td>
            </tr>
            <tr>
              <td class="info01">`+ _that.gn.dic.l["Speed"] + `:</td>
              <td class="info02">`+ parseInt(obj.speed) + ` Km/h</td>
            </tr>
            <tr>
              <td class="info01">`+ _that.gn.dic.l["Location"] + `:</td>
              <td class="info02">`+ obj.location + `</td>
            </tr>
          </table>
          `
          infowindow.setContent(_htmlInfo);
          infowindow.open(this.historyMap, marker);
        });
        setTimeout(() => {
          google.maps.event.trigger(marker, 'click');
        }, 500);
      }
    }
  }

  moveMouseOnChart(_ev) {
    var rec = _ev.target.getBoundingClientRect()
    var _x = _ev.clientX - rec.x
    if (_x < 30) { _x = 30 }
    if (_x > rec.width - 20) { _x = rec.width - 20 }
    document.getElementById('VeritcalLine').style.left = _x + 'px'
  }

  generateChartData() {
    var chartData = [];
    var chartData1 = [];
    for (var i = 0; i < this._speed.length; i++) {
      chartData1.push({
        date: this._dt[i],
        visits: this._speed[i],
        speedlimit: this._speedLimit[i],
        fuel: this.Fuel[i],
        ignition: this._ign[i] + '' == '1' ? 'green' : 'red',
        minodometer: i == 0 ? this.Odometer[i] : null,
        maxodometer: i == this._speed.length - 1 ? this.Odometer[i] : null
      });
    }


    return chartData1;
  }

  generateChartDataMultiple() {
    var chartData = [];
    var chartData1 = [];

    for (var i = 0; i < this._dt.length; i++) {
      var obj1 = {};
      obj1["date"] = this._dt[i];
      obj1['visits' + this.driverVehicles[0].vid] = this._speed[i];
      chartData1.push(obj1);
    }
    if (this.driverVehicles.length > 1) {
      for (var j = 0; j < this._dt2.length; j++) {
        var obj2 = {};
        obj2["date"] = this._dt2[j];
        obj2['visits' + this.driverVehicles[1].vid] = this._speed2[j];
        chartData1.push(obj2);
      }
    }
    if (this.driverVehicles.length > 2) {
      for (var k = 0; k < this._dt3.length; k++) {
        var obj3 = {};
        obj3["date"] = this._dt3[k];
        obj3['visits' + this.driverVehicles[2].vid] = this._speed3[k];
        chartData1.push(obj3);
      }
    }

    chartData1.sort(this.sortFunction);
    return chartData1;
  }
  sortFunction(a, b) {
    var dateA = new Date(a.date).getTime();
    var dateB = new Date(b.date).getTime();
    return dateA > dateB ? 1 : -1;
  };
  sortFunction1(a, b) {
    var dateA = new Date(a.dateOrg).getTime();
    var dateB = new Date(b.dateOrg).getTime();
    return dateA > dateB ? 1 : -1;
  };
  DrawChart() {
    // console.log('DrawChart()')
    this.ignOffOne = []
    var start = moment(this.recData[0].datetime, "YYYY-MM-DD HH:mm:ss");
    var end = moment(this.recData[this.recData.length - 1].datetime, "YYYY-MM-DD HH:mm:s");
    var _diff = moment.duration(end.diff(start)).asSeconds();
    var _lastign = '1';
    var _tmp;
    var _tmp2
    for (var r = 0; r < this.recData.length; r++) {
      if (this.recData[r].di1 + '' == '0' && _lastign == '1') _tmp = this.recData[r].datetime
      if ((r == (this.recData.length - 1) || this.recData[r].di1 + '' == '1') && _lastign == '0') {
        _tmp2 = this.recData[r].datetime
        var starttmp = moment(_tmp, "YYYY-MM-DD HH:mm:ss");
        var endtmp = moment(_tmp2, "YYYY-MM-DD HH:mm:s");
        var _difftmp = moment.duration(endtmp.diff(starttmp)).asSeconds();
        var _widthtmp = (_difftmp / _diff) * 100

        var starttmp1 = moment(start, "YYYY-MM-DD HH:mm:ss");
        var endtmp1 = moment(_tmp, "YYYY-MM-DD HH:mm:s");
        var _difftmp1 = moment.duration(endtmp1.diff(starttmp1)).asSeconds();
        var _lefttmp = (_difftmp1 / _diff) * 100

        this.ignOffOne.push({ width: _widthtmp + '%', left: _lefttmp + '%' })
      }
      _lastign = this.recData[r].di1 + '';
    }

    var tformat1 = 'JJ:NN:SS';//this.gn.user.DFormat + ' JJ:NN:SS'
    var tformat2 = 'fff'
    var tformat3 = 'JJ:NN'
    if (this.gn.user.TFormat.indexOf('H') == -1) {
      tformat1 = 'KK:NN:SS A';//this.gn.user.DFormat + ' JJ:KK:SS'
      tformat2 = 'ss'
      tformat3 = 'KK:NN A'
    }
    this.MyChartData = this.generateChartData();
    console.log('this.MyChartData=' + this.MyChartData.length)
    var ChartConfig = {
      // "listeners": [
      //   {
      //     "event": "changed",
      //     "method": (e) => {
      //       //debugger
      //       _that.MyChart.chartCursor.categoryBalloonColor = 'orange'
      //       console.log(1)
      //       //_that.recData[e.index].di1
      //     }
      //   }
      // ],

      "type": "serial",
      "theme": "light",
      "marginRight": 20,
      "autoMarginOffset": 20,

      "marginTop": 7,
      "dataProvider": this.MyChartData,
      "valueAxes": [
        {
          "position": "left",
          "axisAlpha": 0.2,
          "dashLength": 1,
          "id": "v1"
        }, {
          "position": "right",
          "axisAlpha": 0.2,
          "dashLength": 1,
          "id": "v2",
          "maximum": this.fuelcapacity,
          "minimum": 0
        },
        {
          "gridAlpha": 0,
          "axisAlpha": 0,
          "labelsEnabled": false,
          "labelRotation": 90,
          "id": "v3"
        },
        // {
        //   "position": "left",
        //   "axisAlpha": 0.2,
        //   "dashLength": 1,
        //   "id": "v4",
        //   "offset": 50,
        //   "maximum": 140,
        //   "minimum": 0,
        //   "axisColor": "#ff0000",
        // }
      ],
      "mouseWheelZoomEnabled": true,
      "graphs": [
        {
          "id": "g1",
          "bulletSize": 24,
          "balloonText": this.dic.l["Speed"] + ": [[value]] Km/h",
          "bullet": "round",
          "bulletBorderAlpha": 1,
          "bulletColor": "#FFFFFF",
          "hideBulletsCount": 50,
          "title": "red line",
          "valueField": "visits",
          "useLineColorForBulletBorder": true,
          "balloon": {
            "drop": false
          },
          "customBullet": "",
          "customBulletField": "customBullet",

          "labelColorField": "",
          "labelText": "",
          "labelPosition": "",


          "lineAlpha": 1,
          "showBalloons": true,
          "visibleInLegend": true,
          "valueAxis": "v1",
          "lineColor": "#75b3d7"
        }
      ],
      "chartScrollbar": {
        "autoGridCount": true,
        "graph": "g1",
        "scrollbarHeight": 40,
        //"backgroundColor": "[[ignition]]"
      },
      "chartCursor": {
        "cursorAlpha": 1,
        //"limitToGraph": "g1",
        "categoryBalloonDateFormat": tformat1,
        //"cursorColor": "blue",
        //"categoryBalloonColor": "blue",
      },
      "categoryField": "date",
      // "categoryBalloonDateFormat": "DD-MM-YYYY JJ:NN:SS",
      // "dataDateFormat": "YYYY-MM-DD",

      "stockLegend": {
        "periodValueTextComparing": "[[percents.value.close]]%",
        "periodValueTextRegular": "[[value.close]]"
      },
      "categoryAxis": {
        // "dateFormat": [
        //   { period: 'fff', format: 'JJ:NN:SS A' },
        //   { period: 'ss', format: 'JJ:NN:SS A' },
        //   { period: 'mm', format: 'JJ:NN' },
        //   { period: 'hh', format: 'JJ:NN' },
        //   { period: 'KK', format: 'JJ:NN A' },
        //   { period: 'DD', format: 'MMM DD' },
        //   { period: 'WW', format: 'MMM DD' },
        //   { period: 'MM', format: 'MMM' },
        //   { period: 'YYYY', format: 'YYYY' }],
        //"dateFormats": [{ "period": 'ss', "format": 'KK:NN:SS A' }, { "period": 'mm', "format": 'KK:NN A' }, { "period": 'hh', "format": 'KK:NN A' }, { "period": 'DD', "format": 'MMM DD' }, { "period": 'WW', "format": 'MMM DD' }, { "period": 'MM', "format": 'MMM' }, { "period": 'YYYY', "format": 'YYYY' }, { "period": 'fff', "format": 'JJ:NN' }],
        //"dateFormats": [{ "period": 'fff', "format": (this.gn.user.TFormat.indexOf('H') == -1 ? 'KK:NN A' : 'JJ:NN') }],

        "dateFormats": [{ "period": 'ss', "format": 'JJ:NN:SS' }, { "period": 'mm', "format": tformat3 }, { "period": 'hh', "format": tformat3 }, { "period": 'DD', "format": 'MMM DD' }, { "period": 'fff', "format": 'JJ:NN' }],


        "minPeriod": tformat2,
        "parseDates": true,
        "axisColor": "#DADADA",
        "dashLength": 1,
        "minorGridEnabled": true,
        "guides": [{
          "date": this.maxSpeedRec[0].dt,
          "lineColor": "#CC0000",
          "lineAlpha": 1,
          "lineThickness": 2,
          "dashLength": 3,
          "inside": true,
          "labelRotation": 90,
          "label": this.Round(this.maxSpeedRec[0].speed) + ' Km/h',
          "balloonText": this.dic.l["maxspeed"]
        }]
      },
      "export": {
        "enabled": true
      }
    }

    if (this.buzzerdt != '2000-01-01' && this.buzzerdt != undefined && this.gn.Vehicles[this.gn.VehiclesDic[parseInt(this.vehicles[0])]].speedlimitalertallow + '' == '1') {
      ChartConfig.categoryAxis.guides.push(
        {
          "date": this.buzzerdt,
          "lineColor": "#000000",
          "lineAlpha": 1,
          "lineThickness": 2,
          "dashLength": 3,
          "inside": true,
          "labelRotation": 90,
          "label": this.dic.l['liveSpeedWarning'],
          "balloonText": this.dic.l['liveSpeedWarning'],
        }
      )
    }

    //if (this.fuelDown.length > 0 && (this.gn.user.ClientId == 753 || this.gn.user.ClientId == 499)) {

    if (this.fuelDown.length > 0 && this.gn.getPriv('susfueldown') && this.currday == 0) {
      for (var f = 0; f < this.fuelDown.length; f++) {
        ChartConfig.categoryAxis.guides.push(
          {
            "date": this.fuelDown[f].dt,
            "lineColor": "#f7d13b",
            "lineAlpha": 1,
            "lineThickness": 2,
            "dashLength": 3,
            "inside": true,
            "labelRotation": 90,
            "label": this.dic.l["SuspiciousFuelDown"],
            "balloonText": this.dic.l["SuspiciousFuelDown"]
          }
        )
      }
    }
    if (this.HaveFuel == true) {
      ChartConfig.graphs.push({
        "id": "g2",
        "bulletSize": 24,
        "balloonText": this.currday == 1 ? "" : this.dic.l["Fuel"] + ": [[value]] lit",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": "#FFFFFF",
        "hideBulletsCount": 50,
        "title": "brown line",
        "valueField": this.currday == 1 ? "" : "fuel",
        "useLineColorForBulletBorder": true,
        "balloon": {
          "drop": false
        },
        "customBullet": "",
        "customBulletField": "customBullet",

        "labelColorField": "",
        "labelText": "",
        "labelPosition": "",

        "lineAlpha": 1,
        "showBalloons": false,
        "visibleInLegend": false,
        "valueAxis": "v2",
        "lineColor": "#f7d13b",
        // @ts-ignore
        "lineThickness": this.currday == 1 ? 0 : 2
      })
    }

    if (this.HaveOdometer == true) {
      ChartConfig.graphs.push({
        "id": "g3",
        "bulletSize": 24,
        "balloonText": "",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": "#FFFFFF",
        "hideBulletsCount": 0,
        "title": "brown line",
        "valueField": "minodometer",
        "useLineColorForBulletBorder": true,
        "balloon": {
          "drop": false
        },
        "customBullet": "assets/imgs/iconRoll.gif",
        "customBulletField": "customBullet",

        "labelColorField": "#2A0CD0",
        "labelText": this.dic.l["Odometer"] + ":<br>[[value]] Km",
        "labelPosition": "right",

        "lineAlpha": 0,
        "showBalloons": false,
        "visibleInLegend": false,
        "valueAxis": "v3",
        "lineColor": "#2A0CD0"
      })

      ChartConfig.graphs.push({
        "id": "g4",
        "bulletSize": 24,
        "balloonText": "",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": "#FFFFFF",
        "hideBulletsCount": 0,
        "title": "brown line",
        "valueField": "maxodometer",
        "useLineColorForBulletBorder": true,
        "balloon": {
          "drop": false
        },
        "customBullet": "assets/imgs/iconRoll.gif",
        "customBulletField": "customBullet",

        "labelColorField": "#2A0CD0",
        "labelText": this.dic.l["Odometer"] + ":<br>[[value]] Km",
        "labelPosition": "left",

        "lineAlpha": 0,
        "showBalloons": false,
        "visibleInLegend": false,
        "valueAxis": "v3",
        "lineColor": "#2A0CD0"
      })
    }
    //speedlimitbuzzer
    if (this.gn.Vehicles[this.gn.VehiclesDic[parseInt(this.vehicles[0])]].speedlimitalertallow + '' == '1') {
      this.hasBuzzOneVeh = true;
      ChartConfig.graphs.push({
        "id": "g5",
        "bulletSize": 24,
        "balloonText": this.dic.l["speedLimit"] + ": [[value]] Km/h",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": "#FFFFFF",
        "hideBulletsCount": 50,
        "title": "brown line",
        "valueField": "speedlimit",
        "useLineColorForBulletBorder": true,
        "balloon": {
          "drop": false
        },
        "customBullet": "",
        "customBulletField": "customBullet",

        "labelColorField": "",
        "labelText": "",
        "labelPosition": "",
        "lineAlpha": 1,
        "showBalloons": false,
        "visibleInLegend": false,
        "valueAxis": "v1",
        "lineColor": "#ff0000"
      })
    }
    //end speedlimitbuzzer


    // ChartConfig.graphs.push({
    //   "id": "g3",
    //   "balloonText": "Max speed: [[value]] Km/h",
    //   "bullet": "round",
    //   "bulletBorderAlpha": 1,
    //   "bulletColor": "#FFFFFF",
    //   "hideBulletsCount": 50,
    //   "title": "brown line",
    //   "valueField": "maxspeed",
    //   "useLineColorForBulletBorder": true,
    //   "balloon": {
    //     "drop": false
    //   },


    //   "lineAlpha": 1,
    //   "showBalloons": false,
    //   "visibleInLegend": false,
    //   "valueAxis": "v3"
    // })

    this.MyChart = this.AmChart.makeChart("chart-canvas", ChartConfig);
    this.MyChart.addListener("rendered", this.zoomChart);
    this.MyChart.zoomOutText = this.dic.l["showall"]

    // this.zoomChart();
    var _that = this

    this.MyChart.chartCursor.addListener("changed", function (event) {
      if (event.index != undefined && _that.MyChart != undefined) {
        //_that.MyChart.chartCursor.cursorColor  = '#FF0000'
        //_that.MyChart.chartCursor.cursorColor = 'yellow'
        // debugger
        _that.playRecIdx = event.index
        _that.moveVehicle(event)
        _that.MyChart.chartCursor.set.node.childNodes[0].attributes[5].value = _that.recData[event.index].di1 + '' == '1' ? '#728347' : '#c0202a';
        _that.MyChart.chartCursor.set.node.childNodes[0].attributes[3].value = '3';

        //_that.MyChart.chartCursor.categoryLineAxis.set.node.childNodes[0].attributes[0].value = '#FF0000'

        // if(_that.MyChart.chartCursor.categoryBalloon.set != null)
        // {
        // 	_that.MyChart.chartCursor.categoryBalloon.set.node.children[0].attributes[7].value = '#FF0000';
        // }
      }
    });
    var _t = this
    this.MyChart.chartCursor.addListener("moved", function (event) {
      if (event.index != undefined) {
        _that.stopRec();
        // debugger
        //_t.MyChart.chartCursor.categoryBalloonColor = 'green'
        //_t.MyChart.cursorColor = 'black'

        //_t.MyChart.graphs[0].balloonText = 'kiki'
        //_t.myChart.chartCursor.color = 'black'
        //_t.myChart.chartCursor.cursorColor = 'black'

        //chart.ngOnChanges({} as SimpleChanges)
        //_that.MyChart.chart.update()
      }
    });
    setTimeout(() => {
      // debugger
      var tmp = <HTMLElement>(document.getElementsByClassName('graph-ignBottom')[0])
      var _l = document.getElementById('chart-canvas').getElementsByTagName('rect').length
      if (document.getElementById('chart-canvas').getElementsByTagName('rect')[_l - 1] != undefined) {
        var tmpWidth = document.getElementById('chart-canvas').getElementsByTagName('rect')[_l - 1].attributes[2].value
        tmp.style.width = parseInt(tmpWidth) + 2 + 'px'
        if (!this.HaveFuel)
          tmp.style.left = 'calc(100% - ' + (parseInt(tmpWidth) + 21) + 'px)'
        else
          tmp.style.left = 'calc(100% - ' + (parseInt(tmpWidth) + 59) + 'px)'

        var tmp1 = <HTMLElement>(document.getElementsByClassName('graph-ignTop')[0])
        tmp1.style.width = parseInt(tmpWidth) + 2 + 'px'
        if (!this.HaveFuel)
          tmp1.style.left = 'calc(100% - ' + (parseInt(tmpWidth) + 21) + 'px)'
        else
          tmp1.style.left = 'calc(100% - ' + (parseInt(tmpWidth) + 59) + 'px)'
      }
    }, 100);
  }

  DrawChartMultiple(vhis) {
    console.log('multiple drawchart', vhis)
    var tformat1 = 'JJ:NN:SS';//this.gn.user.DFormat + ' JJ:NN:SS'
    var tformat2 = 'fff'
    var tformat3 = 'JJ:NN'
    if (this.gn.user.TFormat.indexOf('H') == -1) {
      tformat1 = 'KK:NN:SS A';//this.gn.user.DFormat + ' JJ:KK:SS'
      tformat2 = 'ss'
      tformat3 = 'KK:NN A'
    }
    if (this.checkR == 0) {
      this.cntMultiple = 0;
    } else {
    }

    this.cntMultiple++;
    console.log(this.driverVehicles.length, this.cntMultiple + '', (this.vehicles.length) + '')
    if (this.recDataMultiple.length > 0 && this.driverVehicles.length > 1 && this.cntMultiple + '' == (this.vehicles.length) + '') {
      this.MyChartData = this.generateChartDataMultiple();
      this.recDataMultiple.sort(this.sortFunction1);

      console.log('#!#' + this.MyChartData.length)

      var ChartConfig = {
        "type": "serial",
        "theme": "light",
        "marginRight": 20,
        "autoMarginOffset": 20,

        "marginTop": 7,
        "dataProvider": this.MyChartData,
        "valueAxes": [
          {
            "position": "left",
            "axisAlpha": 1,
            "dashLength": 2,
            "id": "v1",
            "axisColor": this.lineColors[0 % 10],
            "axisThickness": 2,
          }, {
            "position": "right",
            "axisAlpha": 1,
            "dashLength": 2,
            "id": "v2",
            "axisColor": this.lineColors[1 % 10],
            "axisThickness": 2,
          },
          {
            "position": "left",
            "axisAlpha": 1,
            "dashLength": 2,
            "id": "v3",
            "axisColor": this.lineColors[2 % 10],
            "axisThickness": 2,
            "offset": 50,
          }
        ],
        "mouseWheelZoomEnabled": true,
        "graphs": [
          {
            "id": "g1",
            "bulletSize": 24,
            "balloonText": this.dic.l["Speed"] + ": [[value]] Km/h",
            "bullet": "round",
            "bulletBorderAlpha": 1,
            "bulletColor": "#FFFFFF",
            "hideBulletsCount": 50,
            "title": "red line",
            "valueField": "visits" + this.driverVehicles[0].vid,//"visits",
            "useLineColorForBulletBorder": true,
            "balloon": {
              "drop": false
            },
            "customBullet": "",
            "customBulletField": "customBullet",

            "labelColorField": "",
            "labelText": "",
            "labelPosition": "",
            "lineColor": this.lineColors[0 % 10],

            "lineAlpha": 1,
            "showBalloons": true,
            "visibleInLegend": true,
            "valueAxis": "v1"
          }
        ],
        "chartScrollbar": {
          "autoGridCount": true,
          "graph": "g1",
          "scrollbarHeight": 40,
          //"backgroundColor": "[[ignition]]"
        },
        "chartCursor": {
          "cursorAlpha": 1,
          //"limitToGraph": "g1",
          "categoryBalloonDateFormat": tformat1,
          //"cursorColor": "blue",
          //"categoryBalloonColor": "blue",
        },
        "categoryField": "date",
        // "categoryBalloonDateFormat": "DD-MM-YYYY JJ:NN:SS",
        // "dataDateFormat": "YYYY-MM-DD",

        "stockLegend": {
          "periodValueTextComparing": "[[percents.value.close]]%",
          "periodValueTextRegular": "[[value.close]]"
        },
        "categoryAxis": {
          "dateFormats": [{ "period": 'ss', "format": 'JJ:NN:SS' }, { "period": 'mm', "format": tformat3 }, { "period": 'hh', "format": tformat3 }, { "period": 'DD', "format": 'MMM DD' }, { "period": 'fff', "format": 'JJ:NN' }],


          "minPeriod": tformat2,
          "parseDates": true,
          "axisColor": "#DADADA",
          "dashLength": 1,
          "minorGridEnabled": true,
          "guides": []
        },
        "export": {
          "enabled": true
        }
      }

      if (this.maxSpeedRec[0] != undefined) {
        ChartConfig.categoryAxis.guides.push({
          "date": this.maxSpeedRec[0].dt,
          "lineAlpha": 1,
          "lineThickness": 2,
          "dashLength": 3,
          "inside": true,
          "labelRotation": 90,
          "label": this.Round(this.maxSpeedRec[0].speed) + ' Km/h',
          "balloonText": this.dic.l["maxspeed"],
          "lineColor": this.lineColors[0 % 10]
        })
      }

      if (this.driverVehicles.length > 1) {
        ChartConfig.graphs.push({
          "id": "g2",
          "bulletSize": 24,
          "balloonText": this.dic.l["Speed"] + ": [[value]] Km/h",
          "bullet": "round",
          "bulletBorderAlpha": 1,
          "bulletColor": "#FFFFFF",
          "hideBulletsCount": 50,
          "title": "red line",
          "valueField": "visits" + this.driverVehicles[1].vid,//"visits",
          "useLineColorForBulletBorder": true,
          "balloon": {
            "drop": false
          },
          "customBullet": "",
          "customBulletField": "customBullet",

          "labelColorField": "",
          "labelText": "",
          "labelPosition": "",
          "lineColor": this.lineColors[1 % 10],

          "lineAlpha": 1,
          "showBalloons": true,
          "visibleInLegend": true,
          "valueAxis": "v2"
        })
        if (this.maxSpeedRec2[0] != undefined) {
          ChartConfig.categoryAxis.guides.push({
            "date": this.maxSpeedRec2[0].dt,
            "lineAlpha": 1,
            "lineThickness": 2,
            "dashLength": 3,
            "inside": true,
            "labelRotation": 90,
            "label": this.Round(this.maxSpeedRec2[0].speed) + ' Km/h',
            "balloonText": this.dic.l["maxspeed"],
            "lineColor": this.lineColors[1 % 10]
          })
        }
      }

      if (this.driverVehicles.length > 2) {
        ChartConfig.graphs.push({
          "id": "g3",
          "bulletSize": 24,
          "balloonText": this.dic.l["Speed"] + ": [[value]] Km/h",
          "bullet": "round",
          "bulletBorderAlpha": 1,
          "bulletColor": "#FFFFFF",
          "hideBulletsCount": 50,
          "title": "red line",
          "valueField": "visits" + this.driverVehicles[2].vid,//"visits",
          "useLineColorForBulletBorder": true,
          "balloon": {
            "drop": false
          },
          "customBullet": "",
          "customBulletField": "customBullet",

          "labelColorField": "",
          "labelText": "",
          "labelPosition": "",
          "lineColor": this.lineColors[2 % 10],

          "lineAlpha": 1,
          "showBalloons": true,
          "visibleInLegend": true,
          "valueAxis": "v3"
        })
        if (this.maxSpeedRec3[0] != undefined) {
          ChartConfig.categoryAxis.guides.push({
            "date": this.maxSpeedRec3[0].dt,
            "lineAlpha": 1,
            "lineThickness": 2,
            "dashLength": 3,
            "inside": true,
            "labelRotation": 90,
            "label": this.Round(this.maxSpeedRec3[0].speed) + ' Km/h',
            "balloonText": this.dic.l["maxspeed"],
            "lineColor": this.lineColors[2 % 10]
          })
        }
      }

      this.MyChart = this.AmChart.makeChart("chart-canvas", ChartConfig);

      this.MyChart.addListener("rendered", this.zoomChart);
      this.MyChart.zoomOutText = this.dic.l["showall"]
      var _that = this

      this.MyChart.chartCursor.addListener("changed", function (event) {
        if (event.index != undefined && _that.MyChart != undefined) {
          _that.playRecIdx = event.index
          _that.moveVehicleMultiple(event)
          _that.MyChart.chartCursor.set.node.childNodes[0].attributes[5].value = _that.recDataMultiple[event.index].di1 + '' == '1' ? '#728347' : '#c0202a';
          _that.MyChart.chartCursor.set.node.childNodes[0].attributes[3].value = '3';
        }
      });
      var _t = this
      this.MyChart.chartCursor.addListener("moved", function (event) {
        if (event.index != undefined) {
          _that.stopRec();
        }
      });
    }
  }

  moveVehicle(event) {
    if (event.index != undefined && this.historyMarker != undefined) {
      var p = this.recData[event.index]

      // console.log(event.index)
      // console.log(this.recData.length)
      // console.log(this.recData)
      this.historyMarker.setPosition(new google.maps.LatLng(parseFloat(p.lat), parseFloat(p.lon)))
      // var _color = 'Red'
      // if (p.di1 + '' == '1') {
      //   _color = 'Green'
      // }

      var _color = 'Gray'
      if (p.di1 + '' == '0' && parseInt(p.sedista) == 0) {
        _color = this.gn.Colors.engineoff
      }
      if (p.di1 + '' == '0' && parseInt(p.sedista) > 0) {
        _color = this.gn.Colors.engineoffpassengeron
      }
      if (p.di1 + '' == '1' && parseInt(p.sedista) > 0 && p.taximeter == '0') {
        _color = this.gn.Colors.taximeteroffpassengeron
      }
      if (p.di1 + '' == '1' && p.taximeter == '1') {
        _color = this.gn.Colors.taximeteron
      }
      if (p.di1 + '' == '1' && parseInt(p.sedista) == 0 && p.taximeter == '0') {
        _color = this.gn.Colors.engineon
      }
      if (p.passive + '' == '1') {
        _color = this.gn.Colors.passiveon
      }
      var vid = this.vehicles[0]
      var _code = this.gn.Vehicles[this.gn.VehiclesDic[vid + '']].code
      this.vs.setVehicleColor(_code, _color, this.gn.Vehicles[this.gn.VehiclesDic[vid + '']], 0)
      // console.log(p.code, p.color, p.ignition)
      // console.log(event.index)
    }
  }
  moveVehicleMultiple(event) {
    if (event.index != undefined) {
      var p = this.recDataMultiple[event.index]
      // console.log(p, this.historyMarker)
      var vid = this.recDataMultiple[event.index].vid;//this.vehicles[0]
      this.historyMarkerMultiple[vid].setPosition(new google.maps.LatLng(parseFloat(p.lat), parseFloat(p.lon)))
      var _color = 'Red'
      if (p.di1 + '' == '1') {
        _color = 'Green'
      }

      var _code = this.gn.Vehicles[this.gn.VehiclesDic[vid + '']].code
      this.vs.setVehicleColor(_code, _color, this.gn.Vehicles[this.gn.VehiclesDic[vid + '']], 0)
      // console.log(p.code, p.color, p.ignition)
      // console.log(event.index)
    }
  }

  doPlayRec() {
    //chartCursor.showCursorAt(cat)
    //for (var i = _i; i < this.recData.length; i++) {
    var _that = this
    console.log(this.playRecIdx)
    var p = _that.recData[this.playRecIdx]
    // console.log(p, this.historyMarker)
    _that.historyMarker.setPosition(new google.maps.LatLng(parseFloat(p.lat), parseFloat(p.lon)))


    //if (!Maps[0].layers[2].markers[0].onScreen())

    this.MyChart.chartCursor.showCursorAt(this._dt[this.playRecIdx])

    var _color = 'Red'
    if (p.di1 + '' == '1') {
      _color = 'Green'
    }
    var vid = _that.vehicles[0]
    var _code = _that.gn.Vehicles[_that.gn.VehiclesDic[vid + '']].code
    _that.vs.setVehicleColor(_code, _color, _that.gn.Vehicles[_that.gn.VehiclesDic[vid + '']], 0)
    // console.log(p.code, p.color, p.ignition)
    // console.log(event.index)
    //}
    if (this.playRecIdx >= this.recData.length - 1) {
      this.tmpInterval = undefined
      this.playRecIdx = this.playRecIdx - 1
      this.playRectf = true;
      this.pb = -2
      this.playrecopt = 0;
      this._timeout = undefined;
      this._timeout1 = undefined;
    }
    if (this.playRecIdx == 0 && this.playrecopt != 1) {
      this.tmpInterval = undefined
      this.playRectf = true;
      this.pb = -2
      this.playrecopt = 0;
      this._timeout = undefined;
      this._timeout1 = undefined;
    }

    if (!(this.historyMap).getBounds().contains((this.historyMarker).getPosition())) {
      this.historyMap.setCenter(new google.maps.LatLng((this.historyMarker).getPosition().lat(), (this.historyMarker).getPosition().lng()))
    }
  }
  playRec(_tf, _inc) {
    if (_tf) {
      //this.stopRec()
      if (_inc == 1)
        this.playrecopt = 1;
      this.playRectf = false;
    }

    //console.log(this.playRecIdx, this.playRectf)
    if (this.playRectf)
      return false;

    if (this.playRecIdx < this.recData.length && this.playRecIdx >= 0) {
      // if (this.pb == 0 && _inc + '' == '1')
      //   this.playRecIdx = this.playRecIdx + _inc;
      // if (this.pb == -1 && _inc + '' == '-1') {
      //   this.playRecIdx = this.playRecIdx + _inc;
      // }
      if (this.pb == -1 && _inc + '' == '1') {

        var _that = this
        _that._timeout = null;
        _that._timeout1 = null;
        this._timeout = setTimeout(function () {
          _that.playRecIdx = _that.playRecIdx + 1;
          _that.pb = -2;

          _that.doPlayRec();
          _that._timeout = setTimeout(function () {
            //console.log('333 ' + _that.playRecIdx)
            //console.log(_that.playRecIdx, _inc, _that.playRecIdx + _inc)
            if ((_that.playRecIdx > 0 && _inc + '' == '-1') || _inc + '' == '1') {
              //alert(_that.playRecIdx + ' ' + _inc)
              //console.log('playrecopt' + _that.playrecopt + ' ' + _inc)
              _that.playRecIdx = _that.playRecIdx + _inc;
              //console.log('333 ' + _that.playRecIdx + ' ' + _inc)
              _that.playRec(true, _inc);
            }
          }, _that.timerSpeed)
          //}, 800)
        }, _that.timerSpeed)
        //}, 1800)

      } else {
        this.doPlayRec();
        var _that = this
        this._timeout = setTimeout(function () {
          //console.log('222 ' + _that.playRecIdx + ' ' + _inc + ' ' + _that._timeout + ' ' + _that._timeout1)
          //console.log(_that.playRecIdx, _inc, _that.playRecIdx + _inc)
          if ((_that.playRecIdx > 0 && _inc + '' == '-1' && _that.playrecopt == -1) || _inc + '' == '1') {
            //console.log('playrecopt' + _that.playrecopt + ' ' + _inc)
            _that.playRecIdx = _that.playRecIdx + _inc;
            //console.log('222 ' + _that.playRecIdx + ' ' + _inc)
            _that.playRec(false, _inc);
          }
        }, _that.timerSpeed)
        //}, 1000)
      }
    }
    // if (_tf) {
    //   this.pb = 1;
    // }
  }

  backRec() {
    this.playrecopt = -1;
    this.pb = -1;
    this.playRectf = true;
    var _that = this;
    this._timeout = null;
    this._timeout1 = setTimeout(function () {
      //console.log('111 ' + _that.playRecIdx)
      if (_that.playRecIdx > 0) {
        _that.playRecIdx = _that.playRecIdx - 1;
        //console.log('111 ' + _that.playRecIdx + ' -1')
        //console.log('playrecopt' + _that.playrecopt + ' -1')
        _that.playRec(true, -1);
      }
    }, _that.timerSpeed)
    //}, 2000)
  }

  stopRec() {
    this.playrecopt = 0;
    this.playRectf = true;
    //this.pb = 0;
  }


  zoomChart() {
    // different zoom methods can be used - zoomToIndexes, zoomToDates, zoomToCategoryValues
    this.MyChart.zoomToIndexes(this.MyChartData.length - 40, this.MyChartData.length - 1);

  }

  showRuler() {
    if (this.measureTool != null) {
      this.hideRuler();
      return;
    }

    // console.log("Ruler activate: START MEASURING !!!")
    this.measureTool = new MeasureTool(this.historyMap, {
      showSegmentLength: true,
      tooltip: true,
      unit: MeasureTool.UnitTypeId.METRIC // metric, imperial, or nautical
    });


    this.measureTool.addListener('measure_start', () => {
      // console.log('started');
      //      this.measureTool.removeListener('measure_start')
    });
    this.measureTool.addListener('measure_end', (e) => {
      // console.log('ended', e.result);
      //      this.measureTool.removeListener('measure_end');
    });
    this.measureTool.addListener('measure_change', (e) => {
      // console.log('changed', e.result);
      //      this.measureTool.removeListener('measure_change');
    });

    this.measureTool.start()

    this.historyMap.setOptions({ draggableCursor: 'crosshair' })
  }


  hideRuler() {
    this.measureTool.end();
    this.measureTool = null;
    this.historyMap.setOptions({ draggableCursor: 'grab' })
  }

  LoadAllStayPois(_id) {
    var _that = this
    var getapi = [_id]
    if (_id == 0) {
      getapi = [1, 2]
    }
    var _vid = this.vehicles[0];
    if (this.driverVehicles.length > 0) {
      var dvArr = this.driverVehicles.map(function (a) {
        return a.vid;
      })
      _vid = dvArr.toString();
    }
    for (var a = 0; a < getapi.length; a++) {
      var _dat = {
        sdate: this.gn.crypt(this.endDate + ' ' + this.startTime),
        edate: this.gn.crypt(this.endDate + ' ' + this.endTime),
        vid: this.gn.crypt(_vid),
        staytype: this.gn.crypt(getapi[a]),
        idleover: this.gn.crypt(this.gn.user.idleover)
      }
      this.gn._Post('/api/gn/reports/getidleengineon', _dat, function (_data) {
        // var img = 'assets/imgs/idleengineon.png'
        // var markerIcon = {
        //   url: img,
        //   scaledSize: new google.maps.Size(24, 24),
        //   origin: new google.maps.Point(0, 0),
        //   anchor: new google.maps.Point(12, 24),
        //   labelOrigin: new google.maps.Point(13, 15)
        // };
        for (var i = 0; i < _data.length; i++) {
          if (_data[i].staytype + '' == '1') {
            var staytypetext = 'idleengineoff'
          }
          if (_data[i].staytype + '' == '2') {
            var staytypetext = 'idleengineon'
          }
          _that.addSartEndMarkerHistoryMap(parseFloat(_data[i].latitude), parseFloat(_data[i].longitude), staytypetext, (i + 1) + '', false, _data[i])
          // var marker = new google.maps.Marker({
          //   position: new google.maps.LatLng(parseFloat(_data[i].latitude), parseFloat(_data[i].longitude)),
          //   map: _that.historyMap,
          //   icon: markerIcon, 
          //   title: _data[i].startdatetime + ' ' + _data[i].enddatetime + ' ' + _data[i].timediff
          // });
        }
      })
    }
  }

  hideStayPoisOnMap() {
    for (var i = 0; i < this.allStops.length; i++) {
      this.allStops[i].setMap(null)
      this.allStops[i] = null
    }
    this.allStops = []
  }

  showStayPoisWindow(_ev) {
    if (this.MapSelectedButton1 == 'IDLE') {
      this.MapSelectedButton1 = ''
      this.hideStayPoisOnMap()
      return
    }
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'staypois', selected: 0, callback: function (_text, _id) {
        _that.MapSelectedButton1 = 'IDLE'
        _that.LoadAllStayPois(_id)
      }
    }, { cssClass: 'map-malkulevo' });
    popover.present({ ev: _ev });
  }

  LoadAllTowUps(_id) {
    var _that = this
    var getapi = [_id]
    // if (_id == 0) {
    //   getapi = [1, 2]
    // }
    var _vid = this.vehicles[0];
    if (this.driverVehicles.length > 0) {
      var dvArr = this.driverVehicles.map(function (a) {
        return a.vid;
      })
      _vid = dvArr.toString();
    }
    //for (var a = 0; a < getapi.length; a++) {
    var _dat = {
      sdate: this.gn.crypt(this.endDate + ' ' + this.startTime),
      edate: this.gn.crypt(this.endDate + ' ' + this.endTime),
      vid: this.gn.crypt(_vid),
      towtype: this.gn.crypt(_id),
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    this.gn._Post('/api/gn/reports/getalltowups', _dat, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        if (_data[i].up + '' == '0') {
          var towtypetext = 'tow0'
        }
        if (_data[i].up + '' == '1') {
          var towtypetext = 'tow1'
        }
        _that.addSartEndMarkerHistoryMap(parseFloat(_data[i].latitude), parseFloat(_data[i].longitude), towtypetext, (i + 1) + '', false, _data[i])

      }
    })
    //}
  }

  hideTowUpsOnMap() {
    for (var i = 0; i < this.allTowUps.length; i++) {
      this.allTowUps[i].setMap(null)
      this.allTowUps[i] = null
    }
    this.allTowUps = []
  }

  showTowUps(_ev) {
    if (this.MapSelectedButton1 == 'TOW') {
      this.MapSelectedButton1 = ''
      this.hideTowUpsOnMap()
      return
    }
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'towups', selected: 0, callback: function (_text, _id) {
        _that.MapSelectedButton1 = 'TOW'
        _that.LoadAllTowUps(_id)
      }
    }, { cssClass: 'map-malkulevo' });
    popover.present({ ev: _ev });
  }

  showPoiWindow(_ev, _type) {
    var _keyPriv = _type;
    if (_type == 'POI') _keyPriv = 'viewpoi';
    if (_type == 'ZONES') _keyPriv = 'viewzones';
    if (this.getPriv(_keyPriv) == false) {
      return false;
    }

    if (this.MapSelectedButton == 'POI') {
      this.selectedGroupID = 1;
      this.MapSelectedButton = ''
      this.MapSelectedButtontmp = ''
      this.hidePoiOnMap()
      this.hideZoneOnMap()
      return
    }
    if (this.MapSelectedButton == 'ZONES') {
      this.selectedGroupID = 1;
      this.MapSelectedButton = ''
      this.MapSelectedButtontmp = ''
      this.hideZoneOnMap()
      return
    }
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'poigroups', selected: 0, callback: function (_text, _ids) {
        _that.selectedGroupID = _ids
        _that.MapSelectedButton = _type
        _that.MapSelectedButtontmp = _type
        if (_type == 'POI') {
          _that.LoadAllPois(_ids)
        } else {
          _that.LoadZones(_ids, true, false)
        }
      }
    }, { cssClass: 'map-malkulevo' });
    popover.present({ ev: _ev });
  }
  // LoadZones(_groupid) {
  //   var _that = this
  //   this.gn._Post('/api/gn/getzones', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), rid: this.gn.crypt(this.gn.user.RoleId), gid: this.gn.crypt(_groupid) }, function (_data) {
  //     _that.AllZones = _data
  //     _that.showZoneOnMap(false)
  //   })
  // }

  LoadZones(_groupid, _show, _tab) {

    var _onlypoly = false
    if (this.MapSelectedButtontmp == 'POI' && !_tab) {
      _onlypoly = true;
    }
    var _that = this
    this.gn._Post('/api/gn/getzones', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), rid: this.gn.crypt(this.gn.user.RoleId), gid: this.gn.crypt(_groupid), onlypoly: this.gn.crypt(_onlypoly) }, function (_data) {
      _that.AllZonesMap = _data
      if (_tab == true && _groupid + '' != '1') {
        _that.gn._Post('/api/gn/getzones', { cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId), rid: _that.gn.crypt(_that.gn.user.RoleId), gid: _that.gn.crypt(1), onlypoly: _that.gn.crypt(_onlypoly) }, function (_data) {
          //_that.AllZonesTab = _data
        })
      } else {
        //if (_tab)
        //_that.AllZonesTab = _data
      }

      if (_show) {
        _that.AllZones = _data
        var _tf = false
        if (_that.MapSelectedButtontmp + '' != '') {
          if (_that.MapSelectedButtontmp == 'POI')
            _tf = true;
          _that.showZoneOnMap(_tf)
        }
      }
    })
  }
  // LoadAllZones() {
  //   // console.log(this.gn.Vehicles)
  //   var _that = this
  //   this.gn._Post('/api/gn/getzones', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), rid: this.gn.crypt(this.gn.user.RoleId), gid: this.gn.crypt(1), poly: this.gn.crypt(true) }, function (_data) {
  //     _that.AllZonesMap = _data
  //   })
  // }
  LoadShowAllZonesGroup() {
    // console.log(this.gn.Vehicles)
    var _onlypoly = false
    if (this.MapSelectedButton == 'POI') {
      _onlypoly = true;
    }
    var _that = this
    this.gn._Post('/api/gn/getzones', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), rid: this.gn.crypt(this.gn.user.RoleId), gid: this.gn.crypt(this.selectedGroupID), poly: this.gn.crypt(true), onlypoly: this.gn.crypt(_onlypoly) }, function (_data) {
      _that.AllZones = _data
      _that.AllZonesMap = _data
      setTimeout(function () {
        _that.showZoneOnMap(false)
      }, 100)
    })
  }
  drawPoly2(_color, _pois, _title, _zoneid) {

    var _pp = []
    var _ppol = []
    for (var i = 0; i < _pois.length; i++) {
      _pp.push({ lat: _pois[i].lat, lng: _pois[i].lon })
      _ppol.push(ol.proj.transform([_pois[i].lon, _pois[i].lat], 'EPSG:4326', 'EPSG:900913'))
    }

    var _poly = new google.maps.Polygon({
      paths: _pp,
      strokeColor: _color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: _color,
      fillOpacity: 0.35
    });
    _poly.setMap(this.historyMap)
    this.Areas.push(_poly)
    _poly.AreaName = _title
    _poly.AreaId = _zoneid
    _poly.AreaColor = _color
    var _that = this
    // google.maps.event.addListener(_poly, "mousemove", function (evn) {
    //   var _html = '@<span class="ion-ios-crop gn-poi-mr" style="float: left; font-size: 20px; color: ' + this.AreaColor + '"></span><span style="float: left; margin-top: 5px">' + this.AreaName + '</span>'
    //   _that.showUnderMouse(_html, _that.googleX - 50, _that.googleY - 90)
    // });
    // google.maps.event.addListener(_poly, "mouseout", function (evn) {
    //   document.getElementById('map-undermouse-popup').setAttribute('gtimer', '0')
    // });      
    _poly.addListener('mouseover', function () {
      var _html = '@<span class="ion-ios-crop gn-poi-mr" style="float: left; font-size: 20px; color: ' + this.AreaColor + '"></span><span style="float: left; margin-top: 5px">' + this.AreaName + '</span>'
      _that.showUnderMouse(_html, _that.googleX - 50, _that.googleY - 90)
    })
    _poly.addListener('mouseout', function () {
      document.getElementById('map-undermouse-popup').setAttribute('gtimer', '0')
    })
    _poly.addListener('click', function () {
      _that.openZoneForEdit(this.AreaId, this.AreaName)
    })

    return this.Areas.length - 1
  }

  // showZoneOnMap() {
  //   // console.log(this.AllZones)
  //   // console.log(_color, _pois, _title
  //   for (var i = 0; i < this.AllZones.length; i++) {
  //     var _pois = this.AllZones[i].pois.split(",")
  //     var pp = []
  //     for (var j = 0; j < _pois.length; j++) {
  //       var tmp = _pois[j].split(' ')
  //       pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
  //     }
  //     this.drawPoly2(this.AllZones[i].color, pp, this.AllZones[i].name, this.AllZones[i].id)
  //   }
  // }

  showZoneOnMap(_poly) {
    var allObj = this.AllZonesMap
    // if (_poly + '' == 'true')
    //   allObj = this.AllPolys

    // console.log(this.AllZones)
    // console.log(_color, _pois, _title

    this.hideZoneOnMap()
    for (var i = 0; i < allObj.length; i++) {
      if ((_poly + '' == 'true' && allObj[i].type + '' == '3') || (_poly + '' != 'true' && allObj[i].type + '' == '2')) {
        var _pois = allObj[i].pois.split(",")
        var pp = []
        for (var j = 0; j < _pois.length; j++) {
          var tmp = _pois[j].split(' ')
          pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
        }
        this.drawPoly2(allObj[i].color, pp, allObj[i].name, allObj[i].id)
      }
    }
  }

  hideZoneOnMap() {
    for (var i = 0; i < this.Areas.length; i++) {
      this.Areas[i].setMap(null)
      this.Areas[i] = null
    }
    this.Areas = []
  }
  reloadPois() {
    this.hidePoiOnMap()
    this.hideZoneOnMap()
    var _that = this
    setTimeout(function () {
      _that.LoadAllPois(_that.lastPoiGroup)
    }, 500)
  }
  // reloadZones() {
  //   this.hideZoneOnMap()
  //   var _that = this
  //   setTimeout(function () {
  //     _that.LoadAllZones()
  //   }, 500)
  // }
  reloadZones1() {
    this.hideZoneOnMap()
    var _that = this
    setTimeout(function () {
      _that.LoadShowAllZonesGroup()
    }, 500)
  }

  // LoadAllPois(_groupid) {
  //   this.lastPoiGroup = _groupid

  //   var _that = this
  //   this.gn._Post('/api/gn/getpois', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), rid: this.gn.crypt(this.gn.user.RoleId), gid: this.gn.crypt(_groupid) }, function (_data) {
  //     _that.AllPois = _data
  //     _that.showPoiOnMap()
  //   })
  // }

  LoadAllPois(_groupid) {
    this.lastPoiGroup = _groupid

    var _that = this
    _that.AllPois = []
    _that.AllZones = []
    this.AllZonesMap = []
    //this.AllZonesTab = []
    //_that.AllPolys = []
    var _onlypoly = false
    if (this.MapSelectedButtontmp == 'POI') {
      _onlypoly = true;
    }
    this.gn._Post('/api/gn/getpois', { clienttypeid: this.gn.crypt(this.gn.clientsettings.clienttypeid), cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), rid: this.gn.crypt(this.gn.user.RoleId), gid: this.gn.crypt(_groupid), onlypoly: this.gn.crypt(_onlypoly) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        //type=1 (poi)
        if (_data[i].pois == "")
          _that.AllPois.push(_data[i])
        //type=3 (poligoni)
        else {
          // if (_data[i].type == 2) {
          //   _that.AllZones.push(_data[i])
          // } else
          if (_data[i].type == 3) {
            //_that.AllPolys.push(_data[i])
            _that.AllZonesMap.push(_data[i])
            //_that.AllZonesTab.push(_data[i])
            //_that.AllZonesMap.push(_data[i])
          }
        }
      }
      _that.showPoiOnMap()
      _that.showZoneOnMap(_onlypoly)
      //_that.LoadShowAllZonesGroup()

    })
  }
  /////

  showPoiOnMap() {
    // var _that = this
    for (var i = 0; i < this.AllPois.length; i++) {
      if (this.AllPois[i].pois == '') {
        var _title = this.AllPois[i].name
        var _color = this.AllPois[i].color
        var _lon = parseFloat(this.AllPois[i].long)
        var _lat = parseFloat(this.AllPois[i].lat)
        var _poiid = this.AllPois[i].id


        var mimage = this.getPin(_color);
        /*no*/var marker = new google.maps.Marker({
          position: new google.maps.LatLng(_lat, _lon),
          map: this.historyMap,
          icon: mimage,

        });
        this.Pois.push(marker)

        marker.PointName = _title
        marker.PointColor = _color
        marker.PoiID = _poiid
        var _that = this
        // google.maps.event.addListener(this.Pois[this.Pois.length-1], "mousemove", function (evn, aaa) {
        //   var _html = '@<span class="ion-ios-pin gn-poi-mr " style="float: left; font-size: 20px; color: ' + this.PointColor + '"></span><span style="float: left; margin-top: 5px">' + this.PointName + '</span>'
        //   _that.showUnderMouse(_html, _that.googleX - 40, _that.googleY - 80)
        //   console.log(_that.googleX, _that.googleY)                
        // });
        // google.maps.event.addListener(this.Pois[this.Pois.length-1], "mouseout", function (evn) {
        //   var el = document.getElementById('map-undermouse-popup')
        //   if (el != null) {
        //     el.setAttribute('gtimer', '0')
        //   }
        // });
        marker.addListener('mouseover', function () {
          // console.log('mouseover')
          var _html = '@<span class="ion-ios-pin gn-poi-mr " style="float: left; font-size: 20px; color: ' + this.PointColor + '"></span><span style="float: left; margin-top: 5px">' + this.PointName + '</span>'
          _that.showUnderMouse(_html, _that.googleX - 80, _that.googleY - 160)
          // console.log(_that.googleX, _that.googleY)     

        })
        marker.addListener('mouseout', function () {
          // console.log('mouseout')
          var el = document.getElementById('map-undermouse-popup')
          if (el != null) {
            el.setAttribute('gtimer', '0')
          }
        })

        marker.addListener('click', function () {
          _that.openPoiForEdit(this.PoiID)
        })

      }
    }
  }
  showUnderMouse(_vehicles, x, y) {
    //console.log('showUnderMouse', _vehicles, x, y)
    var el = document.getElementById('map-undermouse-popup')
    if (this.lastUMouse != _vehicles) {
      var _html = ''
      if (_vehicles[0] != '@') {
      }
      else {
        _html = '<span>' + _vehicles.substring(1) + '</span>'
      }

      if (el != null) {
        el.innerHTML = _html
      }
      this.lastUMouse = _vehicles
    }
    if (el != null) {
      el.setAttribute('gtimer', '15')
      // console.log((x - 300 + 10) + 'px', (y - 60 + 10) + "px")
      el.style.top = (y - 60 + 10) + "px"
      el.style.left = (x - 300 + 10) + 'px'

    }
    // $('#map-undermouse-popup').attr('gtimer', '5').css({ top: (y - 60 + 10) + 'px', left: (x - 300 + 10) + 'px' })
  }

  hidePoiOnMap() {
    for (var i = 0; i < this.Pois.length; i++) {
      this.Pois[i].setMap(null)
      this.Pois[i] = null
    }
    this.Pois = []
  }

  getPin(_color, _icon = "\uf1e5", _drawSCircle = false) {
    var canvas = <HTMLCanvasElement>document.createElement('CANVAS')
    canvas.width = 40
    canvas.height = 64
    var ctx = canvas.getContext("2d");
    ctx.font = "32px Ionicons"
    ctx.fillStyle = _color;
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'black';
    //62550 //\f456
    // ctx.fillText("\uf456",2,29);
    // ctx.strokeText("\uf456",2,29);

    ctx.fillText(_icon, 2, 29);
    ctx.strokeText(_icon, 2, 29);
    if (_drawSCircle == true) {
      ctx.beginPath();
      ctx.arc(10, 15, 6, 0, 2 * Math.PI, false);
      ctx.fill();
    }
    return canvas.toDataURL();
  }

  timerUnderMouse() {
    // console.log('timerUnderMouse')
    var el = document.getElementById('map-undermouse-popup')
    if (el != null) {
      var tmr = parseInt(el.getAttribute('gtimer'))//parseInt($('#map-undermouse-popup').attr('gtimer'))
      if (tmr > 0) {
        tmr = tmr - 1
        el.setAttribute('gtimer', tmr + '')
      }
    }

  }


  ///////NEWWWWW
  openAddMenu(_ev) {
    if (this.MapSelectedButton == 'ADDPOI' || this.MapSelectedButton == 'ADDZONE' || this.MapSelectedButton == 'ADD') {
      if (this.MapType == 'OSMM') { document.getElementById('mapFull').style.cursor = '' }
      if (this.MapType == 'GOOGLE') { this.historyMap.setOptions({ draggableCursor: '' }) }
      //this.MapSelectedButton = ''
      this.MapSelectedButton = this.MapSelectedButtontmp
      this.newZonePoints = []
      this.clearNewZoneLayers()
      return
    }
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'addonmap', selected: 0, callback: function (_text, _ids) {
        if (_ids == 'POI') {
          //Add poi
          _that.drawPOIOnMap()
        }
        if (_ids == 'ZONE') {
          //Add ZONE
          _that.drawZoneOnMap()
        }
      }
    }, { cssClass: 'map-malkulevo' });
    popover.present({ ev: _ev });
    // console.log(_that.MapSelectedButton)
  }

  drawPOIOnMap() {
    this.MapSelectedButton = 'ADDPOI'
    let toast = this.toastCtrl.create({
      message: this.dic.l["infoAddOnMap"],
      duration: 3000, position: 'top'
    });
    toast.present();
    if (this.MapType == 'OSMM') { document.getElementById('mapFull').style.cursor = 'crosshair' }
    if (this.MapType == 'GOOGLE') { this.historyMap.setOptions({ draggableCursor: 'crosshair' }) }
  }
  drawZoneOnMap() {
    this.MapSelectedButton = 'ADDZONE'
    let toast = this.toastCtrl.create({
      message: this.dic.l["infoAddOnMapZOne"],
      duration: 3000, position: 'top',
    });
    toast.present();
    if (this.MapType == 'OSMM') { document.getElementById('mapFull').style.cursor = 'crosshair' }
    if (this.MapType == 'GOOGLE') { this.historyMap.setOptions({ draggableCursor: 'crosshair' }) }
  }


  drawNewZone() {
    // console.log('vleze li')
    var _pp = []
    var _ppol = []
    for (var i = 0; i < this.newZonePoints.length; i++) {
      _pp.push({ lat: this.newZonePoints[i].lat, lng: this.newZonePoints[i].lon })
      _ppol.push(ol.proj.transform([this.newZonePoints[i].lon, this.newZonePoints[i].lat], 'EPSG:4326', 'EPSG:900913'))
    }

    if (this.MapType == 'OSMM') {
      this.clearNewZoneLayers()
      if (_ppol.length > 1) {
        var _styleLine = new ol.style.Style({ stroke: new ol.style.Stroke({ color: '#f00', width: 2 }) })
        var featureLine = new ol.Feature({ geometry: new ol.geom.MultiLineString([_ppol]) })
        var lyrLine = new ol.layer.Vector({ source: new ol.source.Vector({ features: [featureLine] }), style: _styleLine })
        this.historyMap.addLayer(lyrLine)
        this.newZoneLayerLine.push(lyrLine)
      }
      if (_ppol.length > 2) {
        var _ppol2 = _ppol
        _ppol2.push(_ppol2[0])
        var _stylePoly = new ol.style.Style({ fill: new ol.style.Fill({ color: [255, 0, 0, 0.3] }) })
        var featurePoly = new ol.Feature({ geometry: new ol.geom.Polygon([_ppol2]) })
        var lyrPoly = new ol.layer.Vector({ source: new ol.source.Vector({ features: [featurePoly] }), style: _stylePoly })
        this.historyMap.addLayer(lyrPoly)
        this.newZoneLayerPoly.push(lyrPoly)
      }

      for (var i = 0; i < _ppol.length; i++) {
        var _styleCircle = new ol.style.Style({
          image: new ol.style.Circle({
            radius: 5, snapToPixel: false, fill: new ol.style.Fill({ color: [255, 0, 0, 0.5] }),
            stroke: new ol.style.Stroke({ color: '#f00', width: 1 })
          })
        })
        var feature = new ol.Feature({ geometry: new ol.geom.Point([_ppol[i][0], _ppol[i][1]]) })
        var lyr = new ol.layer.Vector({ source: new ol.source.Vector({ features: [feature] }), style: _styleCircle })
        this.historyMap.addLayer(lyr)
        this.newZoneLayerPoints.push(lyr)
      }


    }
    if (this.MapType == 'GOOGLE') {
      this.clearNewZoneLayers()
      if (_pp.length > 1) {
        var _Line = new google.maps.Polyline({ path: _pp, strokeColor: '#f00', strokeOpacity: 1, strokeWeight: 2 });
        _Line.setMap(this.historyMap)
        this.newZoneLayerLine.push(_Line)
      }
      if (_pp.length > 2) {
        var _poly = new google.maps.Polygon({ paths: _pp, strokeWeight: 0, fillColor: '#f00', fillOpacity: 0.3 });
        _poly.setMap(this.historyMap)
        this.newZoneLayerPoly.push(_poly)
      }
      for (var i = 0; i < _pp.length; i++) {
        /*no*/var marker = new google.maps.Marker({
        draggable: true,
        position: _pp[i], icon: { path: google.maps.SymbolPath.CIRCLE, scale: 4, strokeColor: '#f00' }, map: this.historyMap
      });
        marker.tempGoran = i
        this.newZoneLayerPoints.push(marker)
        var _that = this
        google.maps.event.addListener(marker, 'dragend', function (event) {
          _that.newZonePoints[this.tempGoran] = { lon: event.latLng.lng(), lat: event.latLng.lat() }
          _that.drawNewZone()
          //event.latLng.lat();
          // event.latLng.lng();          
        });
      }
    }

  }

  openModalAddPoi(_lat, _lon) {
    // console.log(_lat, _lon)
    //AddPoiMapPage
    var _that = this
    const modal = this.modalCtrl.create(AddpoimapPage, {
      id: -1, lat: _lat, lon: _lon, cb: function () {
        if (_that.MapSelectedButton == 'ADDPOI' || _that.MapSelectedButton == 'ADDZONE' || _that.MapSelectedButton == 'ADD') {
          if (_that.MapType == 'OSMM') { document.getElementById('mapFull').style.cursor = '' }
          if (_that.MapType == 'GOOGLE') { _that.historyMap.setOptions({ draggableCursor: '' }) }
          _that.MapSelectedButton = ''
          //NEW!!!!
          if (_that.MapSelectedButtontmp == 'POI') {
            setTimeout(function () {
              _that.MapSelectedButton = 'POI'
              _that.MapSelectedButtontmp = 'POI'
            }, 1500)
            _that.reloadPois();
          }
          if (_that.MapSelectedButtontmp == 'ZONES') {
            _that.MapSelectedButton = 'ZONES'
          }
        }
      }
    });
    modal.present();
  }
  openModalAddZone() {
    if (this.newZonePoints.length < 3) {
      let toast2 = this.toastCtrl.create({
        message: this.dic.l["poimissinzone"],
        duration: 3000,
        position: 'top'
      });
      toast2.present();
      return
    }
    // this.MapSelectedButton
    var _that = this
    const modal = this.modalCtrl.create(AddzonePage, {
      id: -1, pois: this.newZonePoints, cb: function (_zonetype) {
        if (_that.MapSelectedButton == 'ADDPOI' || _that.MapSelectedButton == 'ADDZONE' || _that.MapSelectedButton == 'ADD') {
          if (_that.MapType == 'OSMM') { document.getElementById('mapFull').style.cursor = '' }
          if (_that.MapType == 'GOOGLE') { _that.historyMap.setOptions({ draggableCursor: '' }) }
          _that.MapSelectedButton = ''
          _that.newZonePoints = []
          _that.clearNewZoneLayers()

          //NEW!!!!
          if (_that.MapSelectedButtontmp == 'ZONES') {
            setTimeout(function () {
              _that.MapSelectedButton = 'ZONES'
              _that.MapSelectedButtontmp = 'ZONES'
              // _that.reloadZones1();

              // _that.LoadAllZones()
              _that.hideZoneOnMap()
              // _that.MapSelectedButton = ''
              var _tab = false
              if (_zonetype + '' == '2')
                _tab = true
              _that.LoadZones(_that.selectedGroupID, true, _tab)
              //_that.reloadZones1();
            }, 500)

          } else {
            setTimeout(function () {
              if (_zonetype + '' == '2') {
                _that.LoadZones(_that.selectedGroupID, true, true)
              }
            }, 500)
          }
          if (_that.MapSelectedButtontmp == 'POI') {
            setTimeout(function () {
              _that.MapSelectedButton = 'POI'
              _that.MapSelectedButtontmp = 'POI'
              _that.reloadPois();
            }, 500)

          }
        }
      }
    });
    modal.present();
  }

  clearNewZoneLayers() {
    if (this.MapType == 'OSMM') {
      if (this.newZoneLayerPoints.length > 0) {
        for (var j = 0; j < this.newZoneLayerPoints.length; j++) { this.historyMap.removeLayer(this.newZoneLayerPoints[j]) }
      }
      if (this.newZoneLayerLine.length > 0) {
        for (var j = 0; j < this.newZoneLayerLine.length; j++) { this.historyMap.removeLayer(this.newZoneLayerLine[j]) }
      }
      if (this.newZoneLayerPoly.length > 0) {
        for (var j = 0; j < this.newZoneLayerPoly.length; j++) { this.historyMap.removeLayer(this.newZoneLayerPoly[j]) }
      }

    }
    if (this.MapType == 'GOOGLE') {
      if (this.newZoneLayerPoints.length > 0) {
        for (var j = 0; j < this.newZoneLayerPoints.length; j++) { this.newZoneLayerPoints[j].setMap(null) }
      }
      if (this.newZoneLayerLine.length > 0) {
        for (var j = 0; j < this.newZoneLayerLine.length; j++) { this.newZoneLayerLine[j].setMap(null) }
      }
      if (this.newZoneLayerPoly.length > 0) {
        for (var j = 0; j < this.newZoneLayerPoly.length; j++) { this.newZoneLayerPoly[j].setMap(null) }
      }
    }
    this.newZoneLayerLine = []
    this.newZoneLayerPoints = []
    this.newZoneLayerPoly = []

  }

  openZoneForEdit(_zoneId, _zoneName) {
    // console.log(_zoneId)
    //debugger;
    // for (var i = 0; i < this.AllPolys.length; i++) {
    //   if (this.AllPolys[i].id + '' == _zoneId + '') {
    //     var _pp = []
    //     var tmpPois = this.AllPolys[i].pois.split(',')
    //     for (var k = 0; k < tmpPois.length; k++) {
    //       var ttt = tmpPois[k].split(' ')
    //       _pp.push({ lon: ttt[1], lat: ttt[0] })
    //     }
    //     var _that = this
    //     var _dat = {
    //       id: _zoneId,
    //       name: _zoneName,
    //       pois: _pp,
    //       type: 1 + '',
    //       cb: function () {
    //         if (_that.MapSelectedButtontmp == 'POI') {
    //           _that.reloadPois()
    //         } else {
    //           // _that.LoadAllZones()
    //           _that.hideZoneOnMap()
    //           // _that.MapSelectedButton = ''
    //           _that.LoadZones(_that.selectedGroupID)
    //           //_that.reloadZones1();
    //         }
    //       },
    //       cb1: function () {
    //         // _that.LoadAllZones()
    //         _that.hideZoneOnMap()
    //         // _that.MapSelectedButton = ''
    //         _that.LoadZones(_that.selectedGroupID)
    //         //_that.reloadZones1();
    //       }
    //     }
    //     const modal = this.modalCtrl.create(AddzonePage, _dat);
    //     modal.present();
    //   }

    // }

    for (var i = 0; i < this.AllZonesMap.length; i++) {
      if (this.AllZonesMap[i].id + '' == _zoneId + '') {
        var _pp = []
        var tmpPois = this.AllZonesMap[i].pois.split(',')
        for (var k = 0; k < tmpPois.length; k++) {
          var ttt = tmpPois[k].split(' ')
          _pp.push({ lon: ttt[1], lat: ttt[0] })
        }
        var _that = this
        var _dat = {
          id: _zoneId,
          name: _zoneName,
          pois: _pp,
          type: _that.AllZonesMap[i].type + '',
          cb: function (_zonetype) {
            if (_that.MapSelectedButtontmp == 'POI') {
              _that.reloadPois()
            } else {
              //_that.reloadPois()
              // _that.LoadAllZones()
              _that.hideZoneOnMap()
              var _tab = false
              if (_zonetype + '' == '2' || _that.MapSelectedButtontmp == 'ZONES')
                _tab = true

              _that.LoadZones(_that.selectedGroupID, true, _tab)
            }

          },
          cb1: function (_zonetype) {
            // _that.LoadAllZones()
            _that.hideZoneOnMap()
            // _that.MapSelectedButton = ''
            var _tab = false
            if (_zonetype + '' == '2' || _that.MapSelectedButtontmp == 'ZONES')
              _tab = true

            _that.LoadZones(_that.selectedGroupID, true, _tab)

            //_that.reloadZones1();
          }
        }
        const modal = this.modalCtrl.create(AddzonePage, _dat);
        modal.present();
      }

    }
  }
  openPoiForEdit(_poid) {
    for (var i = 0; i < this.AllPois.length; i++) {
      // console.log(this.AllPois)
      if (this.AllPois[i].id + '' == _poid + '') {
        var _dat = {
          id: _poid,
          lon: this.AllPois[i].long,
          lat: this.AllPois[i].lat,
          groupid: this.AllPois[i].groupid,
          available: this.AllPois[i].available,
          name: this.AllPois[i].name,
          radius: this.AllPois[i].radius,
          cb: function () {
            _that.reloadPois()
          }
        }
        var _that = this
        const modal = this.modalCtrl.create(AddpoimapPage, _dat);
        modal.present();
      }


    }
  }

  distance(x1: any, y1: any, x2: any, y2: any) {
    var length = 0;
    var wgs84Sphere = new ol.Sphere(6378137);
    length += wgs84Sphere.haversineDistance([x1, y1], [x2, y2]);
    return length;
  }

  changeTimerSpeed(_e) {
    if (_e._value > this.timerSpeedInit) {
      this.timerSpeed = this.timerSpeedInit - (_e._value - this.timerSpeedInit)
    } else {
      if (_e._value < this.timerSpeedInit) {
        this.timerSpeed = this.timerSpeedInit + (this.timerSpeedInit - _e._value)
      } else {
        this.timerSpeed = this.timerSpeedInit
      }
    }
    this.timerSpeedVal = _e._value;
    console.log(_e._value + ' ' + this.timerSpeed)
  }




  HideContextMenuGoolge(ContextMenu) {
    ContextMenu.style.display = "none";
    document.oncontextmenu = function () {
      return true;
    }
  }

  ShowContextMenuGoolge(ContextMenu, event) {
    document.oncontextmenu = function () {
      return false;
    }
    console.log(event.pixel.y)
    ContextMenu.style.top = event.pixel.y + "px";
    ContextMenu.style.left = event.pixel.x + "px";
    ContextMenu.style.display = "block";
  }

  setDirections(_what) {
    var _that = this
    this.gn.Socket.emit({ lon: this._copyCoords[0], lat: this._copyCoords[1] }, function (_data) {
      document.getElementById('my-context-menu').style.display = 'none'

      if (_what == 0) {


        _that.tochkiPoseta[0] = ({ ispoi: 0, id: 's', name: "дестинација", ppid: 0, txt: _data.address, lon: _that._copyCoords[0], lat: _that._copyCoords[1], marker: null })

      }

      if (_what == 1) {

        _that.tochkiPoseta.push({ ispoi: 0, id: 'm', name: _data.address, ppid: 0, txt: _data.address, lon: _that._copyCoords[0], lat: _that._copyCoords[1], marker: null });
        _that.reorderItems(_that.tochkiPoseta.length - 2, _that.tochkiPoseta.length - 1);

      }

      if (_what == 2) {
        _that.tochkiPoseta[_that.tochkiPoseta.length - 1] = ({ ispoi: 0, id: 'e', name: _data.address, ppid: 0, txt: _data.address, lon: _that._copyCoords[0], lat: _that._copyCoords[1], marker: null })

      }

      document.getElementById('map-directions').style.display = ''
    }, 'getreversegeocode')
  }

  closeMapDirections() {
    document.getElementById('map-directions').style.display = 'none'
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      if (this.tochkiPoseta[i].marker != null) {
        this.tochkiPoseta[i].marker.setMap(null)
        this.tochkiPoseta[i].marker = null
      }
    }
    this.tochkiPoseta = []
    this._Distance = ''
    this._totaltime = 0
    this.totaltime2 = ''
    this.totaldistance2 = '0'
    this.tochkiPoseta[0] = { ispoi: 1, id: 's', name: "дестинација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null }
    this.tochkiPoseta[1] = { ispoi: 1, id: 'e', name: "дестинација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null }
    this.ClearLine()
    this.disablebutton = false
    this.calcfromleftpanel = false
    // this.selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
    // this.selectedVehicleName2 = '--- ' + this.dic.l["choosevehicle"] + ' ---';
    // this.selectedVehicleId = ''
    // this.selectedVehicleId2 = -1;
  }

  copyCoords(vid = -1) {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    if (vid == -1)
      inp.value = this._copyCoords[1] + ', ' + this._copyCoords[0]
    else
      inp.value = this.gn.Vehicles[this.gn.VehiclesDic[vid]].lat + ', ' + this.gn.Vehicles[this.gn.VehiclesDic[vid]].lon

    inp.select();
    document.execCommand('copy', false);
    inp.remove();
    if (vid == -1)
      this.HideContextMenuGoolge(this.ContextMenu);

    let toast = this.toastCtrl.create({
      message: this.dic.l["coordcopied"],
      duration: 3000,
      position: 'top'
    });
    toast.present();

  }

  copyAddress() {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = this._copyAddress

    inp.select();
    document.execCommand('copy', false);
    inp.remove();
    this.HideContextMenuGoolge(this.ContextMenu);

    let toast = this.toastCtrl.create({
      message: this.dic.l["addresscopied"],
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }


  reorderItems(from, to) {
    // console.log(from, to)
    let element = this.tochkiPoseta[from];
    this.tochkiPoseta.splice(from, 1);
    this.tochkiPoseta.splice(to, 0, element);
  }

  // loadMapRouting() {
  //   this.MapRouting.setCenter({ lat: 41.998802, lng: 21.427379 })
  // }

  txtchange(_ev) {
    this.disablebutton = false
    var _txt = _ev.target.value
    var t = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
    }
    this.AutoCompleteTitle = _txt

    // if(this.tochkiPoseta[0].lat != 0){

    // }
    // console.log(this.AutoCompleteTitle, 'this.AutoCompleteTitle')
    // this.AutoCompleteTitle

    // var _that = this
    if (t != '') {
      this.searchGeocode(_ev.target.value)
    } else {
      this.mapSearcData = []
      this.AutoCompleteState = 0
      // console.log (_that.mapSearcData)
    }
  }

  searchGeocode(txt) {
    txt = txt.toLowerCase()
    // txt = txt.replace(/ /g,'%')
    //console.log(txt)
    if (txt == '') {
      this.mapSearcData = []
      this.AutoCompleteState = 0
      return
    }
    var _that = this
    var _lon = 21.427379
    var _lat = 41.998802
    this.LoadingDataSearch = true
    _that.AutoCompleteState = 1
    this.gn.Socket.emit({ query: txt, lon: _lon, lat: _lat, clientid: this.gn.user.ClientId }, function (_data) {
      _that.mapSearcData = _data
      _that.LoadingDataSearch = false
      if (_data.length == 0) {
        _that.AutoCompleteState = 2
      } else {
        _that.AutoCompleteState = 1
      }
      // console.log (_that.mapSearcData)
    }, 'getgeocode2')
  }
  openAutocomplete(_ev, _idx) {
    this.AutoCompleteIndex = _idx
    this.mapSearcData = []
    this.LoadingDataSearch = false
    this.AutoCompleteState = 0
    this.InFocused = true
    var _txt = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
      this.AutoCompleteState = 0
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
      this.AutoCompleteState = 1
    }
    this.searchGeocode(_ev.target.value)
    this.AutoCompleteTitle = _txt
    var _top = _ev.target.parentNode.parentNode.parentNode.parentNode.parentNode.offsetTop
    this.AutoCompleteShow = true
    this.AutoCompleteTop = (_top + 71) + 'px'
  }
  hideAutocomplete() {
    this.InFocused = false
    var _that = this
    setTimeout(function () {
      if (_that.InFocused == false) {
        _that.AutoCompleteShow = false
      }
    }, 150)
    // this.AutoCompleteShow = false
  }


  doitemACClick(_itm) {
    // group: "Скопје"
    // lat: "42.002795"
    // lon: "21.458244"
    // name: "16 Makedonska brigada"
    // ppid: 0
    // type: "gc"
    this.AutoCompleteShow = false
    this.tochkiPoseta[this.AutoCompleteIndex].txt = _itm.name
    this.tochkiPoseta[this.AutoCompleteIndex].lon = _itm.lon
    this.tochkiPoseta[this.AutoCompleteIndex].lat = _itm.lat
    this.tochkiPoseta[this.AutoCompleteIndex].ispoi = _itm.ispoi

    if (this.tochkiPoseta[this.AutoCompleteIndex].marker != null) {
      for (var i = 0; i < this.Areas.length; i++) {
        if (this.Areas[i].id == this.tochkiPoseta[this.AutoCompleteIndex].ppid) {
          this.Areas[i].setMap(null)
          this.Areas.splice(i, 1);
        }
      }
    }

    this.tochkiPoseta[this.AutoCompleteIndex].ppid = _itm.ppid

    if (this.tochkiPoseta[this.AutoCompleteIndex].marker != null) {
      this.tochkiPoseta[this.AutoCompleteIndex].marker.setMap(null)
      this.tochkiPoseta[this.AutoCompleteIndex].marker = null
    }
    var img = 'assets/imgs/newpin-blue.png'
    if (this.AutoCompleteIndex == 0) { img = 'assets/imgs/newpin-green.png' }
    if (this.AutoCompleteIndex == this.tochkiPoseta.length - 1) { img = 'assets/imgs/newpin-red.png' }

    var markerIcon = {
      url: img,
      scaledSize: new google.maps.Size(38, 43),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(13, 43),
      labelOrigin: new google.maps.Point(13, 13)
    };

   /*done*/this.tochkiPoseta[this.AutoCompleteIndex].marker = new google.maps.Marker({
      position: { lat: parseFloat(_itm.lat), lng: parseFloat(_itm.lon) },
      map: this.historyMap,
      icon: markerIcon, //'assets/imgs/pin-blue.png',
      label: {
        text: (parseInt(this.AutoCompleteIndex + '') + 1) + '',
        color: "#000",
        fontSize: "14px",
        fontWeight: "bold",
      },
    });
    // this.MapRouting.panTo(new google.maps.LatLng(parseFloat(_itm.lat), parseFloat(_itm.lon)));
    // this.MapRouting.setZoom(15)

    if (_itm.type != 'poi') {
      var _that = this
      this.gn._Post('/api/gn/getonezone', { zid: this.gn.crypt(_itm.ppid) }, function (_data) {
        // console.log(_data[0])
        for (var i = 0; i < _data.length; i++) {
          // console.log()
          var _pois = _data[i].pois.split(",")
          var pp = []
          for (var j = 0; j < _pois.length; j++) {
            var tmp = _pois[j].split(' ')
            pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
          }
          // console.log(_data[i].color, pp, _data[i].name)
          // var idx = _that.drawPoly(_data[i].color, pp, _data[i].name, _id)
          // _that.tempZones[_id + ''] = { data: _data, index: idx }
          // _that.CenterMap2thisPois(pp)
          // _that.drawPoly(_data[i].color, pp, _data[i].name, _itm.ppid)
        }
      })
    }
    // = {id:'s',name:"дестинација", ppid: 0, txt: '', lon: 0, lat: 0}  
  }

  itemACClick(_itm) {
    if (_itm.lon + '' == '0' && _itm.lat + '' == '0') {
      var _that = this;
      this.gn.Socket.emit({ locationid: _itm.sid }, function (_data) {
        _itm.lon = _data[0].lon
        _itm.lat = _data[0].lat
        _that.doitemACClick(_itm)
      }, 'getll0')
    } else {
      this.doitemACClick(_itm)
    }
  }




  drawLine(_points) {
    var _Line = new google.maps.Polyline({
      path: _points,
      strokeColor: '#0000ff',
      strokeOpacity: 1,
      strokeWeight: 2
    });
    _Line.setMap(this.historyMap)
    this.PathLines.push(_Line)
  }

  drawLine2(_points2) {
    var _Line2 = new google.maps.Polyline({
      path: _points2,
      strokeColor: '#3A7C00',
      strokeOpacity: 1,
      strokeWeight: 2
    });
    _Line2.setMap(this.historyMap)
    this.PathLines.push(_Line2)
  }
  ClearLine() {
    console.log('daj da vidam')
    this.RouteDetails = false
    for (var i = 0; i < this.PathLines.length; i++) {
      this.PathLines[i].setMap(null)
      this.PathLines[i] = null
    }
    this.PathLines = []

    for (var i = 0; i < this.PathLines2.length; i++) {
      this.PathLines2[i].setMap(null)
      this.PathLines2[i] = null
    }
    this.PathLines2 = []

    this.shortRoute = true;
    this.fastRoute = true;

  }
  showHideRouteLine(_type, _cbtxt) {
    var _els = document.getElementsByClassName("routetype");
    var _el1 = <HTMLElement>_els[0]
    var _el2 = <HTMLElement>_els[1]
    if (_type == 'short') {
      if (this.shortRoute) {
        this.PathLines[0].setMap(null)
        _el1.style.opacity = '0.5'
      } else {
        this.PathLines[0].setMap(this.historyMap)
        _el1.style.opacity = '1'
      }
      this.shortRoute = !this.shortRoute;
    }
    if (_type == 'fast') {
      if (_cbtxt == '') {
        if (this.fastRoute) {
          this.PathLines[1].setMap(null)
          _el2.style.opacity = '0.5'
        } else {
          this.PathLines[1].setMap(this.historyMap)
          _el2.style.opacity = '1'
        }
      } else {
        if (this.fastRoute) {
          this.PathLines2[0].setMap(null)
          _el2.style.opacity = '0.5'
        } else {
          this.PathLines2[0].setMap(this.historyMap)
          _el2.style.opacity = '1'
        }
      }
      this.fastRoute = !this.fastRoute;
    }
  }


  deleteTochka(idx) {
    for (var i = 0; i < this.Areas.length; i++) {
      if (this.Areas[i].id == this.tochkiPoseta[idx].ppid) {
        this.Areas[i].setMap(null)
        this.Areas.splice(i, 1);
      }
    }
    if (this.tochkiPoseta[idx].marker != null) {
      this.tochkiPoseta[idx].marker.setMap(null)
      this.tochkiPoseta[idx].marker = null
    }

    this.tochkiPoseta.splice(idx, 1)
    this.pointCount = this.tochkiPoseta.length
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }

  CalculateRoute() {
    console.log('dali vleguvas tuka')
    this.ClearLine();
    this.totaldistance2 = '0';

    var _pts = []
    var _that = this
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      if (this.tochkiPoseta[i].lat != 0) {
        _pts.push({ lon: this.tochkiPoseta[i].lon, lat: this.tochkiPoseta[i].lat })
      }
    }
    // console.log(_pts, '_pts')
    if (_pts.length < 2) {
      // MSG: Mora da imate barem dve tocki vneseno
      const alert = this.alertCtrl.create({
        subTitle: this.dic.l["routeinfo2"],
        buttons: [this.dic.l['ok']]
      });
      alert.present();

      return
    } else {
      var _optimum = 'shortest'
      var _TollRoad = "no";
      var _Highways = "no";
      var _Ferry = "no";

      this.loadDataCalculate = true;
      this.gn.Socket.emit({ routeby: this.gn.clientsettings.routeby, cid: this.gn.user.ClientId, uid: this.gn.user.UserId, points: _pts, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: _optimum, Unit: "k" }, function (_data) {
        _that.gn.Socket.emit({ routeby: _that.gn.clientsettings.routeby, cid: _that.gn.user.ClientId, uid: _that.gn.user.UserId, points: _pts, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: 'fastest', Unit: "k" }, function (_data2) {

          _that.loadDataCalculate = false;

          var _pp = []
          var _pp2 = []

          var _pposm = []
          var _pposm2 = []

          _that.linestring2 = 'LINESTRING ('

          for (var i = 0; i < _data2.routes.length; i++) {
            var _route2 = _data2.routes[i]
            for (var j = 0; j < _route2.points.length; j++) {
              _that.linestring2 += parseFloat(_route2.points[j].lng) + ' ' + parseFloat(_route2.points[j].lat) + ', ';
              _pp2.push({ lat: parseFloat(_route2.points[j].lat), lng: parseFloat(_route2.points[j].lng) })
              _pposm2.push(ol.proj.transform([_route2.points[j].lng, _route2.points[j].lat], 'EPSG:4326', 'EPSG:900913'))

            }
          }
          _that.linestring2 = _that.linestring2.substring(0, _that.linestring2.length - 2)
          _that.linestring2 += ')'

          // var bounds = new google.maps.LatLngBounds();
          // _that.linestring = 'LINESTRING ('
          // for (var i = 0; i < _data.routes.length; i++) {
          //   var _route = _data.routes[i]
          //   for (var j = 0; j < _route.points.length; j++) {
          //     _that.linestring += parseFloat(_route.points[j].lng) + ' ' + parseFloat(_route.points[j].lat) + ', ';
          //     _pp.push({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) })
          //     _pposm.push(ol.proj.transform([_route.points[j].lng, _route.points[j].lat], 'EPSG:4326', 'EPSG:900913'))
          //     bounds.extend({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) });
          //   }
          // }
          // _that.linestring = _that.linestring.substring(0, _that.linestring.length - 2)
          // _that.linestring += ')'


          var bounds = new google.maps.LatLngBounds();
          _that.linestring = 'LINESTRING ('
          for (var i = 0; i < _data.routes.length; i++) {
            var _route = _data.routes[i]
            for (var j = 0; j < _route.points.length; j++) {
              _that.linestring += parseFloat(_route.points[j].lng) + ' ' + parseFloat(_route.points[j].lat) + ', ';
              _pp.push({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) })
              _pposm.push(ol.proj.transform([_route.points[j].lng, _route.points[j].lat], 'EPSG:4326', 'EPSG:900913'))
              bounds.extend({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) });
            }
          }
          _that.linestring = _that.linestring.substring(0, _that.linestring.length - 2)
          _that.linestring += ')'

          _that._Distance = parseFloat(_data.distance).toFixed(1)
          _that._totaltime = parseInt(_data.time)

          _that.totaltime2 = _that.formatSec(parseInt(_data2.time))
          _that.totaldistance2 = parseFloat(_data2.distance).toFixed(1)

          _that._totaltimeStr = _that.formatSec(_that._totaltime)

          _that.historyMap.fitBounds(bounds);
          _that.drawLine(_pp)
          _that.drawLine2(_pp2)

          var cb = _that.navParams.get("callback")
          if (cb != null) {
            cb(_pp, bounds, _pp2, _pposm, _pposm2, 0)
          }
          _that.RouteDetails = true
          _that.disablebutton = true

        }, 'getDirections')
      }, 'getDirections')
    }
  }

  clearAp(_txt) {
    return (_txt + '').replace(/\"/g, "")
  }

  addRoute(_ev) {
    var _points = []
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      var pp = this.tochkiPoseta[i]
      if (pp.lon + '' != '0' && pp.lat + '' != '0') {
        var pnt = '{"ispoi": ' + this.clearAp(pp.ispoi) + ', "txt":"' + this.clearAp(pp.txt) + '", "lon":"' + this.clearAp(pp.lon) + '", "lat":"' + this.clearAp(pp.lat) + '", "ppid":"' + this.clearAp(pp.ppid) + '", "checked":"0"}'
        _points.push(pnt)
      }
    }

    if (_points.length < 2) {
      const alert = this.alertCtrl.create({ subTitle: this.dic.l["routeinfo2"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this.tochkiPoseta[0].name != 'дестинација' && this.selectedVehicleId + '' != '-1') {
      var driverid = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].driver
      var vehicleid = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].vehicleid
      if (driverid + '' != '/') {
        var _that = this
        this.gn._Post('/api/gn/getvehicledriver', { vid: _that.gn.crypt(parseInt(vehicleid + '')) }, function (_data) {
          // _that.driverid = _data.id
          _that.savenalog(_data[0].driverid)
        })

      } else {
        const alert = this.alertCtrl.create({ subTitle: this.dic.l["addvehicledriverforroute"] + ' ' + this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].registration, buttons: [this.dic.l['ok']] });
        alert.present();
        return
      }
    } else {
      var _that = this
      // this.gn._Post('/api/gn/getalldriversandvehicles', { cid: _that.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      let popover = _that.popoverCtrl.create(PopupPage, {
        type: 'alldriversandvehicles', selected: [], callback: function (_text, _ids) {
          _that.gn._Post('/api/gn/getvehicledriverfromdriverid', { did: _that.gn.crypt(_ids) }, function (_data) {
            // for (let pp = 0; pp < _data; pp++) {
            //   if (_ids + '' == _data[pp].driverid + '')
            //     debugger
            _that.selectedVehicleId = _data[0].vehicleid
            // }
            // _that.selectedVehicleId = _ids
            _that.savenalog(_ids)
          })
        }
      }, { cssClass: 'calcdriver-popover' })

      popover.present({ ev: _ev });
    }
  }

  savenalog(_driverId) {

    var _points = []
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      var pp = this.tochkiPoseta[i]
      if (pp.lon + '' != '0' && pp.lat + '' != '0') {
        var pnt = '{"ispoi": ' + this.clearAp(pp.ispoi) + ', "txt":"' + this.clearAp(pp.txt) + '", "lon":"' + this.clearAp(pp.lon) + '", "lat":"' + this.clearAp(pp.lat) + '", "ppid":"' + this.clearAp(pp.ppid) + '", "checked":"0"}'
        _points.push(pnt)
      }
    }

    var _that = this
    var dr1 = "0"; if (this.selectedDriverIds.length >= 1) { dr1 = this.selectedDriverIds[0] }
    //sovozaci
    var dr2 = "0"; if (this.selectedCoDriversIds.length >= 1) { dr2 = this.selectedCoDriversIds[0] }
    var dr3 = "0"; if (this.selectedCoDriversIds.length >= 2) { dr3 = this.selectedCoDriversIds[1] }
    var dr4 = "0"; if (this.selectedCoDriversIds.length >= 3) { dr4 = this.selectedCoDriversIds[2] }

    var p1 = "0"; if (this.SelPauses.length >= 1) { p1 = this.SelPauses[0] }
    var p2 = "0"; if (this.SelPauses.length >= 2) { p2 = this.SelPauses[1] }
    var p3 = "0"; if (this.SelPauses.length >= 3) { p3 = this.SelPauses[2] }
    var p4 = "0"; if (this.SelPauses.length >= 4) { p4 = this.SelPauses[3] }
    var p5 = "0"; if (this.SelPauses.length >= 5) { p5 = this.SelPauses[4] }

    var _dt = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.selectedTime

    // var date = new Date()

    var _dt = moment(new Date()).format('YYYY-MM-DD') + ' ' + this.selectedTime


    var _pointsStr = '[' + _points.join(',') + ']'

    // ke gi preklopam shortest so fastest promenilivite
    var types = 'shortest'

    if (this.typeofroute == 'fastest') {
      this._Distance = this.totaldistance2
      this._totaltimeStr = this.totaltime2
      this.linestring = this.linestring2
      types = 'fastest'
      // _that._Distance = parseFloat(_data.distance).toFixed(1) + ' Km'
      // _that._totaltime = parseInt(_data.time)

      // _that.totaltime2 = _that.formatSec(parseInt(_data2.time))
      // _that.totaldistance2 = parseFloat(_data2.distance).toFixed(1) + ' Km'
      // this.RouteTotalDistance = this.RouteTotalDistance2
    }


    var hCul = 0
    var _dat = {
      vid: this.gn.crypt(this.vehicles),
      driver1: this.gn.crypt(_driverId),
      driver2: this.gn.crypt(dr2),
      driver3: this.gn.crypt(dr3),
      driver4: this.gn.crypt(dr4),
      dt: this.gn.crypt(_dt),
      title: this.gn.crypt(this.RouteTitle),
      id: this.gn.crypt(this.NalogId),
      routenum: this.gn.crypt(this.NalogNum),
      cid: this.gn.crypt(this.gn.user.ClientId),
      uid: this.gn.crypt(this.gn.user.UserId),
      zad: this.gn.crypt(parseInt(this.idle)),
      Pause1: this.gn.crypt(p1),
      Pause2: this.gn.crypt(p2),
      Pause3: this.gn.crypt(p3),
      Pause4: this.gn.crypt(p4),
      Pause5: this.gn.crypt(p5),
      TotalKm: this.gn.crypt(this._Distance),
      linestring: this.gn.crypt(this.linestring),
      TotalTime: this.gn.crypt(this._totaltime),
      optimized: this.gn.crypt('optimized'),

      culA: this.gn.crypt(this.selectedCultureId),
      culB: this.gn.crypt(this.selectedOperationId),
      culC: this.gn.crypt(this.selectedMaterialId),
      culD: this.gn.crypt(this.selectedMechanId),
      cul: this.gn.crypt(hCul),
      points: this.gn.crypt(_pointsStr),
      cnt: this.gn.crypt(_pointsStr.length),
      driveruser: this.gn.crypt(_driverId)
    }

    // this.driverUser = dr1




    var logroute = 'Нов налог: ' + (this.RouteTitle == '' ? '/' : this.RouteTitle)
    if (this.NalogId != -1) {
      logroute = 'Промена на налог: ' + this.NalogId
    }
    var vida = [];
    vida.push(this.selectedVehicleId);
    this.gn.addLog(38, logroute);
    this.gn.loadWaiting();


    this.gn._Post('/api/gn/saveroute', _dat, function (_data) {

      _that.gn.loaderWaiting.dismiss();

      console.log(_data, 'sto se slucuva')


      if (_data.checkformesss == 'ok1') {
        var dat2 = {
          fromuid: _that.gn.crypt(_that.gn.user.UserId),
          touid: _that.gn.crypt(_driverId),
          message: _that.gn.crypt('#routetodriver#' + _data.nalid),
          messnotification: _that.gn.crypt(_that.dic.l["newroute"] + ': ' + _data.nalid)

        }
        _that.gn._Post('/api/gn/createMessageFromRouteRegular', dat2, function (_data2) {
        })
      }




      const alert = _that.alertCtrl.create({ subTitle: _that.dic.l["SaveOrderDone"], buttons: [_that.dic.l['ok']] });
      alert.present();
    })
  }

  ionViewWillUnload() {
    if (!this._ksource) {
      return false;
    }
    if (this.popovertemp != undefined) {
      this.popovertemp.dismiss();
      this.popovertemp = undefined;
    }
  }


  openCalcDistance(_ev) {
    console.log('dali vlagas tuka')
    var _that = this
    this.popovertemp = this.popoverCtrl.create(CalcdistancePage, {
      type: 'vehicles-follow-live', onlyonevehicle: false, selected: this.vehicles, reconstruction: 1, callback: function (_points, _bds, _points2, _pointsosm, _pointsosm2, close) {

        if (close == 1) {
          if (_that.PathLines.length > 0) {
            if (_that.MapType == 'GOOGLE') {
              for (var i = 0; i < _that.PathLines.length; i++) {
                _that.PathLines[i].setMap(null)
                _that.PathLines[i] = null
              }

              for (var i = 0; i < _that.PathLines2.length; i++) {
                _that.PathLines2[i].setMap(null)
                _that.PathLines2[i] = null
              }
            }
            if (_that.MapType == 'OSMM') {
              for (var i = 0; i < _that.PathLines.length; i++) {
                _that.historyMap.removeLayer(_that.PathLines[i])
                _that.PathLines[i] = null
              }

              for (var i = 0; i < _that.PathLines2.length; i++) {
                _that.historyMap.removeLayer(_that.PathLines[i])
                _that.PathLines2[i] = null
              }
            }
            _that.PathLines = []
            _that.PathLines2 = []
          }
        } else {
          if (_that.MapType == 'GOOGLE') {
            var _Line2 = new google.maps.Polyline({
              path: _points2,
              strokeColor: '#3A7C00',
              strokeOpacity: 1,
              strokeWeight: 2
            });

            var _Line = new google.maps.Polyline({
              path: _points,
              strokeColor: '#0000ff',
              strokeOpacity: 1,
              strokeWeight: 2
            });

            if (_that.PathLines.length > 0) {
              console.log(_that.PathLines, '_that.PathLines, sto se slucuvaso patnive liniii')
              for (var i = 0; i < _that.PathLines.length; i++) {
                _that.PathLines[i].setMap(null)
                _that.PathLines[i] = null
              }

              for (var i = 0; i < _that.PathLines2.length; i++) {
                _that.PathLines2[i].setMap(null)
                _that.PathLines2[i] = null
              }
            }


            _that.PathLines = []
            _that.PathLines2 = []

            _Line.setMap(_that.historyMap)
            _Line2.setMap(_that.historyMap)

            _that.PathLines.push(_Line)
            _that.PathLines2.push(_Line2)

            _that.historyMap.fitBounds(_bds);
          }
          if (_that.MapType == 'OSMM') {

            var _style2 = new ol.style.Style({
              stroke: new ol.style.Stroke({
                color: '#3A7C00',
                width: 2
              })
            })
            var feature2 = new ol.Feature({
              geometry: new ol.geom.MultiLineString([_pointsosm2])
            })
            var lyr2 = new ol.layer.Vector({
              source: new ol.source.Vector({ features: [feature2] }),
              style: _style2
            })

            var _style = new ol.style.Style({
              stroke: new ol.style.Stroke({
                color: '#0000ff',
                width: 2
              })
            })
            var feature = new ol.Feature({
              geometry: new ol.geom.MultiLineString([_pointsosm])
            })
            var lyr = new ol.layer.Vector({
              source: new ol.source.Vector({ features: [feature] }),
              style: _style
            })

            // console.log(_that.PathLines, '_that.PathLines')
            if (_that.PathLines.length > 0) {

              for (var i = 0; i < _that.PathLines.length; i++) {
                _that.historyMap.removeLayer(_that.PathLines[i])
                _that.PathLines[i] = null
              }

              for (var i = 0; i < _that.PathLines2.length; i++) {
                _that.historyMap.removeLayer(_that.PathLines[i])
                _that.PathLines2[i] = null
              }
            }

            _that.PathLines = []
            _that.PathLines2 = []

            _that.historyMap.addLayer(lyr2)
            _that.historyMap.addLayer(lyr)

            _that.PathLines.push(lyr)
            _that.PathLines.push(lyr2)

            var lat_min = 41.998207; var lat_max = 41.998207; var lng_min = 21.426381; var lng_max = 21.426381;

            for (var i = 0; i < _points.length; i++) {

              var ll = ol.proj.transform([_points[i].lng, _points[i].lat], 'EPSG:4326', 'EPSG:900913')
              var _lon = ll[0]
              var _lat = ll[1]
              if (i == 0) {
                lat_min = _lat
                lat_max = _lat
                lng_min = _lon
                lng_max = _lon
              } else {
                if (_lat < lat_min) { lat_min = _lat }
                if (_lat > lat_max) { lat_max = _lat }
                if (_lon < lng_min) { lng_min = _lon }
                if (_lon > lng_max) { lng_max = _lon }
              }
            }
            var ext = [lng_min, lat_min, lng_max, lat_max]
            _that.historyMap.getView().fit(ext, _that.historyMap.getSize())

            // _that.getView().fit(ext, _that.Map.getSize())


          }
        }
      },
      callback1: function (_type, _tf) {
        if (_type == 'short') _that.shortRoute = _tf
        if (_type == 'fast') _that.fastRoute = _tf
        _that.showHideRouteLine(_type, 'cb');
      }

      //}, { enableBackdropDismiss: false, cssClass: 'map-malkulevo2' });
    }, { cssClass: 'popover-content-live' });

    let ev = {
      target: {
        getBoundingClientRect: () => {
          return {
            top: 80,
            left: window.screen.width
          };
        }
      }
    };

    this.popovertemp.present({ ev });
  }


}



// WEBPACK FOOTER //
// ./src/pages/reports/reconstrunction/reconstrunction.ts